// import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
// import { Box, Typography, Button, TextField, InputAdornment, Paper, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Select, MenuItem, FormControl, Alert, useTheme, Divider, Menu, Checkbox, FormControlLabel, IconButton, ListItemIcon, ListItemText, Drawer, RadioGroup, Radio, Badge, Popover, SelectChangeEvent, FormGroup } from '@mui/material';
// import { gql, useQuery, useMutation } from '@apollo/client';
// import { useNavigate, useLocation, useOutletContext} from 'react-router-dom';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import {
//     FiberManualRecord as FiberManualRecordIcon,
//     KeyboardArrowDown as KeyboardArrowDownIcon,
//     MoreHoriz as MoreHorizIcon,
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import SuccessToast from '../../SuccessToast';
// import DataSourceDetailPanel from './DataSourceDetailPanel';
// import DeleteDataSourceDialog from './DeleteDataSourceDialog';
// import ValidationResultPanel, { ValidationDataSource } from './ValidationResultPanel';
// import { Chip, SxProps, Theme } from '@mui/material';
// import ErrorDSTableDisplay from './Error-DS-table-Display';

// export interface Tenant {
//   id: string;
//   name: string;
// }

// interface Creator {
//     id: string;
//     name: string | null;
//     photo?: string | null;
// }

// interface CloudDataSource {
//   __typename: 'DataSource';
//   id: string;
//   name: string;
//   providerType: 'GCP' | 'AWS' | 'AZURE';
//   validationStatus: 'Valid' | 'Invalid' | 'Pending' | string;
//   isSyncing: boolean;
//   lastValidatedAt: string | null;
//   createdAt: string;
//   creator: Creator;
//   validationErrors?: any;
// }

// interface LlmDataSource {
//   __typename: 'LlmDataSource';
//   id: string;
//   name: string;
//   providerType: 'LANGFUSE';
//   projectId: string;
//   createdAt: string;
//   creator: Creator;
// }

// type AnyDataSource = CloudDataSource | LlmDataSource;

// type ColumnVisibilityState = {
//     dataSourceName: boolean;
//     cloudProvider: boolean;
//     status: boolean;
//     lastModifiedBy: boolean;
//     lastValidated: boolean;
//     addedBy: boolean;
//     addedOn: boolean;
// };

// interface DataSourcesPageProps {
//   currentTenant: Tenant | null;
// }

// const allColumns = [
//   { id: 'dataSourceName', label: 'Data Source Name', locked: true, draggable: false },
//   { id: 'status', label: 'Status', locked: true, draggable: false },
//   { id: 'cloudProvider', label: 'Cloud Provider', locked: false, draggable: false },
//   { id: 'lastModifiedBy', label: 'Last Modified By', locked: false, draggable: true },
//   { id: 'lastValidated', label: 'Last Validated', locked: false, draggable: false },
//   { id: 'addedBy', label: 'Added By', locked: false, draggable: false },
//   { id: 'addedOn', label: 'Added On', locked: false },
// ];

// const GET_ALL_DATA_SOURCES_BY_TENANT = gql`
//   query GetAllDataSources($tenantId: ID!) {
//     allDataSourcesByTenant(tenantId: $tenantId) {
//       __typename
//       ... on DataSource {
//         id
//         name
//         providerType
//         validationStatus
//         isSyncing
//         lastValidatedAt
//         createdAt
//         validationErrors
//         creator {
//           id
//           name
//           photo
//         }
//       }
//       ... on LlmDataSource {
//         id
//         name
//         providerType
//         projectId
//         createdAt
//         creator {
//           id
//           name
//           photo
//         }
//       }
//     }
//   }
// `;

// const DELETE_DATA_SOURCE = gql`
//   mutation DeleteDataSource($id: ID!, $providerType: ProviderType!) {
//     deleteDataSource(id: $id, providerType: $providerType)
//   }
// `;

// const getProviderIcon = (providerType: string): string => {
//   switch (providerType) {
//     case 'GCP': return '/icons/google-cloud-icon-2048x1646-7admxejz.svg';
//     case 'LANGFUSE': return '/icons/llm-observability-blue.svg';
//     case 'AWS': return '/icons/aws.png';
//     case 'AZURE': return '/icons/azure.svg';
//     default: return '';
//   }
// };

// const formatDate = (dateString: string | null | undefined): string => {
//   if (!dateString) { return 'N/A'; }
//   const date = new Date(dateString);
//   if (isNaN(date.getTime())) { return 'Invalid Date'; }

//   const datePart = date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
//   const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
//   return `${datePart} • ${timePart}`;
// };

// const getStatusChipSx = (status: string): SxProps<Theme> => {
//     switch (status?.toLowerCase()) {
//         case 'syncing': return { backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'rgba(255, 152, 0, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(255, 152, 0, 1)' };
//         case 'valid': return { backgroundColor: 'rgba(3, 166, 90, 0.1)', color: 'rgba(3, 166, 90, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(3, 166, 90, 1)' };
//         case 'invalid': return { backgroundColor: 'rgb(240, 213, 211)', color: 'rgba(202, 43, 32, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(202, 43, 32, 1)' };
//         default: return { backgroundColor: 'grey.200', color: 'grey.800', fontWeight: 500, border: '1px solid grey.400' };
//     }
// };

// const DataSourcesPage: React.FC<DataSourcesPageProps> = ({ currentTenant }) => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { userRole } = useOutletContext<{ userRole?: string }>();

//   const [isValidationPanelOpen, setIsValidationPanelOpen] = useState(false);
//   const handleOpenValidationPanel = () => { setIsValidationPanelOpen(true); };
//   const handleCloseValidationPanel = () => { setIsValidationPanelOpen(false); };

//   const [columnVisibility, setColumnVisibility] = useState<ColumnVisibilityState>({
//       dataSourceName: true, cloudProvider: true, status: true,
//       lastModifiedBy: true, lastValidated: true, addedBy: true, addedOn: true,
//   });
//   const [tempColumnVisibility, setTempColumnVisibility] = useState<ColumnVisibilityState>(columnVisibility);
//   const [columnMenuAnchorEl, setColumnMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isColumnMenuOpen = Boolean(columnMenuAnchorEl);

//   const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
//   const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const [selectedDataSource, setSelectedDataSource] = useState<AnyDataSource | null>(null);
//   const isActionMenuOpen = Boolean(actionMenuAnchorEl);

//   const [toastOpen, setToastOpen] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');
//   const [isPanelOpen, setIsPanelOpen] = useState(false);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

//   const [isLoadingValidation, setIsLoadingValidation] = useState(false);
//   const [validationError, setValidationError] = useState(false);

//   const validationButtonRef = useRef<HTMLButtonElement>(null);
//   const [showValidationPopover, setShowValidationPopover] = useState(false);

//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(6);
//   const [providerMenuAnchorEl, setProviderMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isProviderMenuOpen = Boolean(providerMenuAnchorEl);

//   const [providerFilters, setProviderFilters] = useState<string[]>([]);
//   const [tempProviderFilters, setTempProviderFilters] = useState<string[]>([]);

//   const handleProviderMenuOpen = (event: React.MouseEvent<HTMLElement>) => { setTempProviderFilters(providerFilters); setProviderMenuAnchorEl(event.currentTarget); };
//   const handleProviderMenuClose = () => setProviderMenuAnchorEl(null);
//   const handleApplyProvider = () => { setProviderFilters(tempProviderFilters); handleProviderMenuClose(); };
//   const handleClearProvider = () => { setTempProviderFilters([]); setProviderFilters([]); handleProviderMenuClose(); };
//   const handleProviderCheckboxChange = (provider: string) => { setTempProviderFilters(prev => prev.includes(provider) ? prev.filter(p => p !== provider) : [...prev, provider]); };

//   const { loading, error, data, refetch } = useQuery<{ allDataSourcesByTenant: AnyDataSource[] }>(
//     GET_ALL_DATA_SOURCES_BY_TENANT,
//     { variables: { tenantId: currentTenant?.id }, skip: !currentTenant?.id, fetchPolicy: 'network-only' }
//   );

//   const fetchValidationData = useCallback(async () => {
//     setIsLoadingValidation(true);
//     setValidationError(false);
//     try { await refetch(); }
//     catch (err) { console.error("Failed to refetch validation data:", err); setValidationError(true); }
//     finally { setIsLoadingValidation(false); }
//   }, [refetch]);

//   useEffect(() => { if (isValidationPanelOpen) { fetchValidationData(); } }, [isValidationPanelOpen, fetchValidationData]);

//   const [deleteDataSource, { loading: deleteLoading }] = useMutation(DELETE_DATA_SOURCE);

//   const allDataSources = data?.allDataSourcesByTenant || [];

//   const syncingCount = useMemo(() => allDataSources.filter(ds => ds.__typename === 'DataSource' && ds.isSyncing).length, [allDataSources]);
//   const validCount = useMemo(() => allDataSources.filter(ds => (ds.__typename === 'DataSource' && !ds.isSyncing && ds.validationStatus === 'Valid') || ds.__typename === 'LlmDataSource').length, [allDataSources]);
//   const invalidCount = useMemo(() => allDataSources.filter(ds => ds.__typename === 'DataSource' && !ds.isSyncing && ds.validationStatus === 'Invalid').length, [allDataSources]);

//   useEffect(() => {
//     const hasDismissed = sessionStorage.getItem('validationPopoverDismissed') === 'true';
//     if (!loading && invalidCount > 0 && !hasDismissed) { setShowValidationPopover(true); }
//   }, [loading, invalidCount]);

//   const handleDismissValidationPopover = () => { setShowValidationPopover(false); sessionStorage.setItem('validationPopoverDismissed', 'true'); };
//   useEffect(() => { if (location.state?.dataSourceAdded) { setToastMessage("Data source added successfully"); setToastOpen(true); navigate(location.pathname, { replace: true, state: {} }); } }, [location, navigate]);
//   useEffect(() => { if (currentTenant) { refetch(); } }, [currentTenant, refetch]);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('All');
//   const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isStatusMenuOpen = Boolean(statusMenuAnchorEl);
//   const [tempStatusFilter, setTempStatusFilter] = useState('All');

//   const filteredData = useMemo(() => {
//     return allDataSources.filter(ds => {
//       const matchesSearch = ds.name.toLowerCase().includes(searchTerm.toLowerCase());
//       const matchesProvider = providerFilters.length === 0 || providerFilters.includes(ds.providerType);

//       if (statusFilter === 'All') { return matchesSearch && matchesProvider; }

//       let currentStatus: string;
//       if (ds.__typename === 'DataSource') { currentStatus = ds.isSyncing ? 'Syncing' : ds.validationStatus; }
//       else { currentStatus = 'Valid'; }
//       const matchesStatus = currentStatus === statusFilter;

//       return matchesSearch && matchesStatus && matchesProvider;
//     });
//   }, [allDataSources, searchTerm, statusFilter, providerFilters]);

//   const pageCount = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData = useMemo(() => filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage), [filteredData, page, rowsPerPage]);
//   const showingFrom = filteredData.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
//   const showingTo = Math.min(page * rowsPerPage, filteredData.length);

//   const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => { setRowsPerPage(event.target.value as number); setPage(1); };
//   const handleNextPage = () => setPage((prevPage) => Math.min(prevPage + 1, pageCount));
//   const handlePreviousPage = () => setPage((prevPage) => Math.max(prevPage - 1, 1));
//   const handleAddDataSourceClick = () => { if (currentTenant?.id) { navigate('/data-sources/add', { state: { tenantId: currentTenant.id } }); } else { alert("Please select a tenant before adding a data source."); } };
//   const handleColumnSelectorClick = (event: React.MouseEvent<HTMLElement>) => { setTempColumnVisibility(columnVisibility); setColumnMenuAnchorEl(event.currentTarget); };
//   const handleColumnSelectorClose = () => setColumnMenuAnchorEl(null);
//   const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => { setTempColumnVisibility({ ...tempColumnVisibility, [event.target.name]: event.target.checked }); };
//   const handleApplyColumns = () => { setColumnVisibility(tempColumnVisibility); handleColumnSelectorClose(); };
//   const handleResetColumns = () => { const newVisibilityState: Partial<ColumnVisibilityState> = {}; allColumns.forEach(column => { newVisibilityState[column.id as keyof ColumnVisibilityState] = true; }); setTempColumnVisibility(newVisibilityState as ColumnVisibilityState); };
//   const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, dataSource: AnyDataSource) => { event.stopPropagation(); setActionMenuAnchorEl(event.currentTarget); setSelectedDataSource(dataSource); };
//   const handleMenuClose = () => setActionMenuAnchorEl(null);
//   const handlePanelClose = () => { setIsPanelOpen(false); setHoveredRowId(null); };
//   const handleEdit = () => { if (selectedDataSource) { navigate(`/data-sources/edit/${selectedDataSource.id}`); } handleMenuClose(); };
//   const handleDelete = () => { setIsDeleteDialogOpen(true); handleMenuClose(); };
//   const handleCloseDeleteDialog = () => setIsDeleteDialogOpen(false);

//   const handleConfirmDelete = async () => {
//     if (!selectedDataSource) return;
//     try {
//       await deleteDataSource({ variables: { id: selectedDataSource.id, providerType: selectedDataSource.providerType } });
//       setToastMessage(`Data source "${selectedDataSource.name}" deleted successfully.`);
//       setToastOpen(true);
//       refetch();
//       handleCloseDeleteDialog();
//     } catch (err) {
//       console.error("Failed to delete data source:", err);
//       handleCloseDeleteDialog();
//     }
//   };

//   const handleStatusMenuOpen = (event: React.MouseEvent<HTMLElement>) => { setTempStatusFilter(statusFilter); setStatusMenuAnchorEl(event.currentTarget); };
//   const handleStatusMenuClose = () => setStatusMenuAnchorEl(null);
//   const handleApplyStatus = () => { setStatusFilter(tempStatusFilter); handleStatusMenuClose(); };
//   const handleClearStatus = () => { setTempStatusFilter('All'); setStatusFilter('All'); handleStatusMenuClose(); };
//   const handleClearAllFilters = () => { setStatusFilter('All'); setProviderFilters([]); setTempStatusFilter('All'); setTempProviderFilters([]); };

//   const CustomValidationBadge = styled(Badge)(({ theme }) => ({ '& .MuiBadge-badge': { backgroundColor: ' rgba(202, 43, 32, 1)', color: '#FF9900', fontsize:'12px', mr:"12px" } }));
//   const getProviderButtonText = () => {
//     const count = providerFilters.length;
//     const totalProviders = 4;
//     if (count === 0) return 'Provider';
//     if (count === totalProviders) return 'All';
//     return providerFilters.join(' & ');
//   };

//   if (!currentTenant) return ( <Box sx={{ p: '24px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><Typography variant="h6" fontFamily={'Inter'}  color="text.secondary">Please select a tenant...</Typography><Button onClick={() => navigate('/dashboard')} sx={{ mt: '16px' }}>Go to Dashboard</Button></Box> );
//   if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: '24px', height: '100%' }}><CircularProgress /></Box>;
//   if (!error && allDataSources.length === 0) return ( <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%', p: { xs: '8px', sm: '16px', md: '24px' } }}><Box sx={{ backgroundColor: 'white', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', p: { xs: '16px', sm: '24px', md: '32px' } }}><Box component="img" src="/icons/No-data-src-added-log.svg" alt="No data sources" sx={{ width: '143px', height: '143px' }} /><Typography variant="h5" component="h1" sx={{ fontWeight: 600, fontSize: '18px', mt: '16px', mb: '12px' }}>No data sources are added yet</Typography><Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '480px', fontSize: '14px', mb: '16px' }}>Click the button below to add data sources...</Typography>{userRole !== 'viewer' && (<Button disableElevation variant="contained" onClick={handleAddDataSourceClick} sx={{fontFamily:'Inter', backgroundColor:'#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}>Add New Data Source</Button>)}</Box></Box>);

//   return (
//     <Box sx={{ p: { xs: '16px', sm: '24px' }, display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', boxSizing: 'border-box' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px', flexShrink: 0 }}>
//          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//            <Typography variant="h6" sx={{ fontSize:'14px', fontWeight: 600 ,mb:-1.3}}>Data Sources ({allDataSources.length})</Typography>
//             <Typography variant="body2" sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: '#666666' }}>Add and manage the connections to your cloud providers to enable cost reporting.</Typography>
//            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//              <Chip icon={ <FiberManualRecordIcon sx={{ fill: theme.palette.success.main, width: '10px', height: '10px' }} /> } label={`Valid Data Sources ${validCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(232, 245, 233, 1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />
//              <Chip icon={ <FiberManualRecordIcon sx={{ fill: '#CA2B20', width: '10px', height: '10px' }} /> } label={`Invalid Data Sources ${invalidCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(202, 43, 32, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none'}} />
//              {syncingCount > 0 && (<Chip icon={ <FiberManualRecordIcon sx={{ fill: 'rgba(255, 152, 0, 1)', width: '10px', height: '10px' }} /> } label={`Syncing Data Sources ${syncingCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />)}
//            </Box>
//          </Box>
//          {userRole !== 'viewer' && (<Button onClick={handleAddDataSourceClick} sx={{ backgroundColor:'#0064FF', width:'179px',height:'36px', textTransform: 'none', fontSize:'14px', fontWeight: 500, borderRadius: '8px',color:' #FFFFFF' }}>Add New Data Source</Button>)}
//        </Box>

//        <Paper elevation={0} sx={{ p: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', borderRadius: '12px', flexShrink: 0 }}>
//           <TextField variant="outlined" size="small" placeholder="Search by data source name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} sx={{ minWidth: { xs: '10px', sm: '250px' }, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontFamily: 'Inter', fontSize: '14px', height: '32px', backgroundColor: 'var(--black-4, rgba(0, 0, 0, 0.04))', color: '#999999', fontWeight: '300', '& fieldset': { border: 0 } }, '& .MuiInputBase-input::placeholder': { opacity: 1, fontWeight:300, fontSize: '14px', color: '#999999' } }} InputProps={{ startAdornment: ( <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="Search" width="17px" height="17px" /></InputAdornment>)}}/>
//         <IconButton onClick={handleColumnSelectorClick} sx={{ p: 0 }}><img src={isColumnMenuOpen ? "/icons/Column_selector_active.svg" : "/icons/Column_selector.svg"} alt="Column Selector" width="32" height="32" /></IconButton>
//         <Button id="status-filter-button" aria-controls={isStatusMenuOpen ? 'status-filter-menu' : undefined} aria-haspopup="true" aria-expanded={isStatusMenuOpen ? 'true' : undefined} variant="contained" onClick={handleStatusMenuOpen} endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isStatusMenuOpen ? 'rotate(180deg)' : 'none' }} />} sx={{ textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px', borderRadius: '8px', boxShadow: 'none', border: '1px solid', borderColor: isStatusMenuOpen || statusFilter !== 'All' ? '#0064FF' : theme.palette.divider, backgroundColor: isStatusMenuOpen || statusFilter !== 'All' ? '#F3F8FE' : 'transparent', '&:hover': { boxShadow: 'none', borderColor: '#0064FF' } }}>
//           {statusFilter === 'All' ? (<Typography component="span" sx={{ fontSize: '14px' }}>Status</Typography>) : (<Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}><Typography component="span" sx={{ fontSize: '14px', fontWeight: 500  }}>Status:</Typography><Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{statusFilter}</Typography></Box>)}
//         </Button>
//         <Menu id="status-filter-menu" anchorEl={statusMenuAnchorEl} open={isStatusMenuOpen} onClose={handleStatusMenuClose} MenuListProps={{ 'aria-labelledby': 'status-filter-button', sx: { p: 0 } }} PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}>
//             <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Select Status</Typography></Box>
//             <Divider />
//             <Box sx={{ py: '8px' }}>
//                 <RadioGroup value={tempStatusFilter} onChange={(e) => setTempStatusFilter(e.target.value)}>
//                     <FormControlLabel value="Syncing" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Syncing" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Syncing' && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Syncing' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
//                     <FormControlLabel value="Valid" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Valid" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Valid' && { backgroundColor: '#F3F8FE'}) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Valid' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
//                     <FormControlLabel value="Invalid" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Invalid" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Invalid' && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Invalid' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
//                 </RadioGroup>
//             </Box>
//             <Divider />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}><Button onClick={handleClearStatus} sx={{ textTransform: 'none', fontSize:'14px', color: tempStatusFilter === 'All' ? '#7B7B7B' : '#333333', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button><Button onClick={handleApplyStatus} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button></Box>
//         </Menu>
//         <Button id="provider-filter-button" aria-controls={isProviderMenuOpen ? 'provider-filter-menu' : undefined} aria-haspopup="true" aria-expanded={isProviderMenuOpen ? 'true' : undefined} variant="contained" onClick={handleProviderMenuOpen} endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isProviderMenuOpen ? 'rotate(180deg)' : 'none' }} />} sx={{ textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px', borderRadius: '8px', boxShadow: 'none', border: '1px solid', borderColor: isProviderMenuOpen || providerFilters.length > 0 ? '#0064FF' : theme.palette.divider, backgroundColor: isProviderMenuOpen || providerFilters.length > 0 ? '#F3F8FE' : 'transparent', '&:hover': { boxShadow: 'none', borderColor: '#0064FF' }, }}>
//           {providerFilters.length === 0 ? (<Typography component="span" sx={{ fontSize: '14px' }}>Provider</Typography>) : (<Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}><Typography component="span" sx={{ fontSize: '14px', fontWeight:500 }}>Provider:</Typography><Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{getProviderButtonText()}</Typography></Box>)}
//         </Button>
//         <Menu id="provider-filter-menu" anchorEl={providerMenuAnchorEl} open={isProviderMenuOpen} onClose={handleProviderMenuClose} MenuListProps={{ 'aria-labelledby': 'provider-filter-button', sx: { p: 0 } }} PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}>
//             <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Select Provider</Typography></Box>
//             <Divider />
//             <Box sx={{ py: '10px' }}>
//                 <FormGroup>
//                     {[ {value: 'GCP', icon: '/icons/google-cloud-icon-2048x1646-7admxejz.svg'}, {value: 'LANGFUSE', icon: '/icons/llm-observability-blue.svg'}, {value: 'AWS', icon: '/icons/aws.svg'}, {value: 'AZURE', icon: '/icons/azure-1.svg'} ].map(p =>
//                         <FormControlLabel key={p.value} control={ <Checkbox checked={tempProviderFilters.includes(p.value)} onChange={() => handleProviderCheckboxChange(p.value)} size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} /> } label={ <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={p.icon} alt={p.value} style={{ height: p.value === 'GCP' ? 27 : 20, width: p.value === 'GCP' ? 21: 20, marginRight: 8 }} />{p.value}</Box> } sx={{ width: '100%', m: 0, px: '1px',pl:'6px', py: '4px', ...(tempProviderFilters.includes(p.value) && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempProviderFilters.includes(p.value) ? '#333333' : '#666666', fontSize: '14px' } } }}/>
//                     )}
//                 </FormGroup>
//             </Box>
//             <Divider />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}><Button onClick={handleClearProvider} sx={{ textTransform: 'none', fontSize:'14px', color: tempProviderFilters.length > 0 ? '#333333' : '#7B7B7B', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button><Button onClick={handleApplyProvider} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button></Box>
//         </Menu>

//         <Divider orientation="vertical" flexItem sx={{ mx: 1, my: '4px' }} />
//         <Button onClick={handleClearAllFilters} sx={{ textTransform: 'none', fontSize: '14px', fontWeight: 500, color: (statusFilter !== 'All' || providerFilters.length > 0) ? '#0064FF' : '#7B7B7B' }}>Clear Filter</Button>
//         <Box sx={{ flexGrow: 1 }} />
//         <CustomValidationBadge variant="dot" invisible={invalidCount === 0} sx={{ "& .MuiBadge-badge": { transform: 'translate(175px, -19px)' } }} />
//             <Button ref={validationButtonRef} variant="contained" onClick={handleOpenValidationPanel} startIcon={<img src="/icons/validation-r.svg" alt="Validation Icon" style={{ width: '12.14px', height: '11.28px' }} />} sx={{ textTransform: 'none', fontWeight: 500, fontSize:'14px', bgcolor: 'rgba(247, 247, 247, 1)', color: 'text.primary', boxShadow: 'none', '&:hover': { boxShadow: 'none' }, borderRadius: '8px' }}>Validation Result</Button>
//       </Paper>

//       <Paper elevation={0} sx={{ width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column', borderRadius: '8px', overflow: 'hidden' }}>
//          {error ? <ErrorDSTableDisplay onRefresh={() => refetch()} /> : (
//             <>
//                 <Box sx={{position: 'relative', flexGrow: 1 }}>
//                     <TableContainer>
//                         <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
//                             <TableHead>
//                                 <TableRow sx={{ '& .MuiTableCell-root': { borderBottom: 'none', paddingTop: '30px' } }}>
//                                     {allColumns.map(col => columnVisibility[col.id as keyof ColumnVisibilityState] && <TableCell key={col.id} sx={{ width: col.id === 'dataSourceName' ? '15%' : col.id === 'cloudProvider' ? '10%' : col.id === 'status' ? '9%' : 'auto', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px', fontWeight: 500, color: '#666666' }}>{col.label}</TableCell>)}
//                                     <TableCell sx={{ width: '60px' }} />
//                                 </TableRow>
//                             </TableHead>
//                             <TableBody>
//                                 {paginatedData.map((row, index) => (
//                                     <TableRow key={row.id} onClick={() => { setSelectedDataSource(row); setIsPanelOpen(true); }} onMouseEnter={() => setHoveredRowId(row.id)} onMouseLeave={() => setHoveredRowId(null)} sx={{ cursor: 'pointer', '& td, & th': { border: 0, padding: '18px', height: '75px' }, backgroundColor: isPanelOpen && selectedDataSource?.id === row.id ? 'rgba(242, 247, 255, 1)' : (index % 2 !== 0 ? 'transparent' : '#F9FAFB'), '&:hover': { backgroundColor: 'rgba(242, 247, 255, 1)' } }}>
//                                         {columnVisibility.dataSourceName && <TableCell component="th" scope="row" sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name}</TableCell>}
                                        
//                                         {/* FIX 1: Swapped the order of these two blocks to match the header */}
//                                         {columnVisibility.status && (
//                                             <TableCell>
//                                                 {row.__typename === 'DataSource' ? (<Chip label={row.isSyncing ? 'Syncing' : row.validationStatus} size="small" sx={getStatusChipSx(row.isSyncing ? 'Syncing' : row.validationStatus)}/>) : (<Chip label="Valid" size="small" sx={getStatusChipSx('Valid')}/>)}
//                                             </TableCell>
//                                         )}
//                                         {columnVisibility.cloudProvider && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img src={getProviderIcon(row.providerType)} alt={row.providerType} style={{ width: '20px', height: '20px' }} />{row.providerType}</Box></TableCell>}
                                        
//                                         {columnVisibility.lastModifiedBy && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}><Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>{!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}</Avatar>{row.creator.name}</Box></TableCell>}
                                        
//                                         {/* FIX 2: Updated the logic for the "Last Validated" column */}
//                                         {columnVisibility.lastValidated && <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.__typename === 'DataSource' ? formatDate(row.lastValidatedAt) : formatDate(row.createdAt)}</TableCell>}
                                        
//                                         {columnVisibility.addedBy && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}><Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>{!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}</Avatar>{row.creator.name}</Box></TableCell>}
//                                         {columnVisibility.addedOn && <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(row.createdAt)}</TableCell>}
//                                         <TableCell>
//                                             {userRole !== 'viewer' && (<IconButton aria-label="actions" onClick={(event) => handleMenuOpen(event, row)} sx={{ visibility: hoveredRowId === row.id || (isActionMenuOpen && selectedDataSource?.id === row.id) ? 'visible' : 'hidden', width: '32px', height: '32px', backgroundColor: '#FFFFFF', border: ' rgb(203, 203, 203) solid 1px', borderRadius: '8px', '&:hover': { backgroundColor: '#F5F5F5' } }}><MoreHorizIcon sx={{ width: '18px', height: 'auto', color: '#333333' }} /></IconButton>)}
//                                         </TableCell>
//                                     </TableRow>
//                                 ))}
//                             </TableBody>
//                         </Table>
//                     </TableContainer>
//                 </Box>
//                 <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, minHeight: '56px', padding: '0 24px', backgroundColor: '#FFFFFF' }}>
//                     <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary' }}>Rows per page:</Typography>
//                     <FormControl size="small"><Select value={rowsPerPage} onChange={handleRowsPerPageChange} sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', '.MuiOutlinedInput-notchedOutline': { border: 'none' }, '.MuiSelect-select': { padding: '4px 8px' } }}><MenuItem value={6}>6</MenuItem><MenuItem value={10}>10</MenuItem><MenuItem value={25}>25</MenuItem></Select></FormControl>
//                     <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', fontWeight: 500 }}>{showingFrom} – {showingTo} of {filteredData.length}</Typography>
//                     <IconButton onClick={handlePreviousPage} disabled={page === 1} aria-label="previous page"><ArrowBackIosNewIcon sx={{ fontSize: '16px' }} /></IconButton>
//                     <IconButton onClick={handleNextPage} disabled={page >= pageCount} aria-label="next page"><ArrowForwardIosIcon sx={{ fontSize: '16px' }} /></IconButton>
//                 </Box>
//             </>
//         )}
//       </Paper>
//       <Drawer anchor="right" open={isPanelOpen} onClose={handlePanelClose} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} PaperProps={{ sx: { borderRadius: '12px', margin: '20px', height: 'calc(100% - 40px)', width: '500px' } }}>
//         <DataSourceDetailPanel dataSourceId={selectedDataSource?.id || null} onClose={handlePanelClose} />
//       </Drawer>
//       <Menu anchorEl={columnMenuAnchorEl} open={isColumnMenuOpen} onClose={handleColumnSelectorClose} MenuListProps={{ 'aria-labelledby': 'column-selector-button', sx: { p: 0 } }} PaperProps={{ sx: { width: '280px', borderRadius: '8px', boxShadow: theme.shadows[2], mt: '8px', overflow: 'hidden' } }}>
//         <Box sx={{ px: '16px', pt: '12px', pb: '8px',borderBottom: `1px solid ${theme.palette.divider}` }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Column selector</Typography></Box>
//         {allColumns.map((column) => {
//           const isChecked = tempColumnVisibility[column.id as keyof typeof tempColumnVisibility] || false;
//           const getBackgroundColor = () => isChecked ? (column.locked ? '#F9FAFB' : 'rgba(237, 246, 255, 1)') : '#FFFFFF';
//           const getHoverBackgroundColor = () => isChecked ? (column.locked ? '#F0F2F5' : 'rgba(220, 235, 255, 1)') : theme.palette.action.hover;
//           return (<MenuItem key={column.id} onClick={() => { if (!column.locked) { handleCheckboxChange({ target: { name: column.id, checked: !isChecked } } as React.ChangeEvent<HTMLInputElement>); } }} disableRipple sx={{ py: '10px', px: '20px', cursor: column.locked ? 'not-allowed' : 'pointer', backgroundColor: getBackgroundColor(), borderBottom: '4px solid #FFFFFF', '&:last-of-type': { borderBottom: 'none' }, '&:hover': { backgroundColor: getHoverBackgroundColor() } }}><Checkbox checked={isChecked} disabled={column.locked} size="small" sx={{ p: 0, mr: '12px', pointerEvents: 'none', color: column.locked ? theme.palette.action.disabled : undefined, '&.Mui-checked': { color: column.locked ? theme.palette.grey[600] : '#0064FF' } }} /><ListItemText primary={column.label} sx={{ flexGrow: 1, '& .MuiListItemText-primary': { fontWeight: 400, fontSize: '14px', color: column.locked ? ' #666666' : ' #333333' } }} />{column.locked && <img src="/icons/lock-icon.svg" alt="Locked" style={{ width: '16px', height: '16px', marginLeft: '8px', opacity: 0.5 }} />}</MenuItem>);
//         })}
//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px', borderTop: `1px solid ${theme.palette.divider}`, alignItems: 'center' }}><Button onClick={handleResetColumns} sx={{ marginRight:'-10px',fontWeight: 500, fontSize: '14px', textTransform: 'none', color:' #7B7B7B' }}>Reset</Button><Button onClick={handleApplyColumns} sx={{ fontWeight: 500, fontSize: '14px', textTransform: 'none', color: ' #0064FF' }}>Apply</Button></Box>
//       </Menu>

//       <SuccessToast open={toastOpen} message={toastMessage} onClose={() => setToastOpen(false)} />
//       <Menu anchorEl={actionMenuAnchorEl} open={isActionMenuOpen} onClose={handleMenuClose} PaperProps={{ sx: { borderRadius: '8px', width: '200px' } }}>
//         <MenuItem onClick={handleEdit}><ListItemIcon><img src="/icons/edit_icon.svg" alt="Edit" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon><ListItemText>Edit</ListItemText></MenuItem>
//         <Divider />
//         <MenuItem onClick={handleDelete} ><ListItemIcon><img src="/icons/delete_icon.svg" alt="Delete" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon><ListItemText sx={{ color:' #CA2B20', fontWeight:400 , fontSize:'14px'}} >Delete</ListItemText></MenuItem>
//       </Menu>

//       <Drawer anchor="right" open={isValidationPanelOpen} onClose={handleCloseValidationPanel} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} PaperProps={{ sx: { borderRadius: '12px', margin: '20px', height: 'calc(100% - 40px)', width: '500px' } }}>
//         <ValidationResultPanel onClose={handleCloseValidationPanel} dataSources={filteredData.filter(ds => ds.__typename === 'DataSource') as unknown as ValidationDataSource[]} loading={isLoadingValidation} error={validationError} onRefresh={fetchValidationData} />
//       </Drawer>

//       <DeleteDataSourceDialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog} onConfirm={handleConfirmDelete} dataSource={selectedDataSource} isDeleting={deleteLoading} />
//       <Popover open={showValidationPopover} anchorEl={validationButtonRef.current} onClose={handleDismissValidationPopover} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} transformOrigin={{ vertical: 'bottom', horizontal: 'center' }} PaperProps={{ sx: { p: 2, mt: 26, ml: 67, borderRadius: '12px', bgcolor: 'rgba(225, 239, 255, 1)', boxShadow: '0px 5px 15px rgba(0,0,0,0.1)', '&::after': { content: '""', position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)', borderWidth: '8px', borderStyle: 'solid', borderColor: 'transparent transparent rgba(225, 239, 255, 1) transparent', marginRight:'100px' } } }}>
//         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: 300 }}><Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 1 }}>Validation issues</Typography><Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>Some data sources have validation issues. View the results to address them.</Typography><Button onClick={handleDismissValidationPopover} sx={{ alignSelf: 'flex-end', fontWeight: 600, textTransform: 'none' }}>Got It</Button></Box>
//       </Popover>
//     </Box>
//   );
// };

// export default DataSourcesPage;


import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Button, TextField, InputAdornment, Paper, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Select, MenuItem, FormControl, Alert, useTheme, Divider, Menu, Checkbox, FormControlLabel, IconButton, ListItemIcon, ListItemText, Drawer, RadioGroup, Radio, Badge, Popover, SelectChangeEvent, FormGroup } from '@mui/material';
import { gql, useQuery, useMutation } from '@apollo/client';
import { useNavigate, useLocation, useOutletContext} from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
    FiberManualRecord as FiberManualRecordIcon,
    KeyboardArrowDown as KeyboardArrowDownIcon,
    MoreHoriz as MoreHorizIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import SuccessToast from '../../SuccessToast';
import DataSourceDetailPanel from './DataSourceDetailPanel';
import DeleteDataSourceDialog from './DeleteDataSourceDialog';
import ValidationResultPanel, { ValidationDataSource } from './ValidationResultPanel';
import { Chip, SxProps, Theme } from '@mui/material';
import ErrorDSTableDisplay from './Error-DS-table-Display';

export interface Tenant {
  id: string;
  name: string;
}

interface Creator {
    id: string;
    name: string | null;
    photo?: string | null;
}

interface CloudDataSource {
  __typename: 'DataSource';
  id: string;
  name: string;
  providerType: 'GCP' | 'AWS' | 'AZURE';
  validationStatus: 'Valid' | 'Invalid' | 'Pending' | string;
  isSyncing: boolean;
  lastValidatedAt: string | null;
  createdAt: string;
  creator: Creator;
  validationErrors?: any;
}

// --- CHANGE 1: Reverted LlmDataSource interface to use 'LANGFUSE' for internal type compatibility ---
interface LlmDataSource {
  __typename: 'LlmDataSource';
  id: string;
  name: string;
  providerType: 'LANGFUSE';
  projectId: string;
  createdAt: string;
  creator: Creator;
}

type AnyDataSource = CloudDataSource | LlmDataSource;

type ColumnVisibilityState = {
    dataSourceName: boolean;
    cloudProvider: boolean;
    status: boolean;
    lastModifiedBy: boolean;
    lastValidated: boolean;
    addedBy: boolean;
    addedOn: boolean;
};

interface DataSourcesPageProps {
  currentTenant: Tenant | null;
}

const allColumns = [
  { id: 'dataSourceName', label: 'Data Source Name', locked: true, draggable: false },
  { id: 'status', label: 'Status', locked: true, draggable: false },
  { id: 'cloudProvider', label: 'Provider', locked: false, draggable: false },
  { id: 'lastModifiedBy', label: 'Last Modified By', locked: false, draggable: true },
  { id: 'lastValidated', label: 'Last Validated', locked: false, draggable: false },
  { id: 'addedBy', label: 'Added By', locked: false, draggable: false },
  { id: 'addedOn', label: 'Added On', locked: false },
];

const GET_ALL_DATA_SOURCES_BY_TENANT = gql`
  query GetAllDataSources($tenantId: ID!) {
    allDataSourcesByTenant(tenantId: $tenantId) {
      __typename
      ... on DataSource {
        id
        name
        providerType
        validationStatus
        isSyncing
        lastValidatedAt
        createdAt
        validationErrors
        creator {
          id
          name
          photo
        }
      }
      ... on LlmDataSource {
        id
        name
        providerType
        projectId
        createdAt
        creator {
          id
          name
          photo
        }
      }
    }
  }
`;

const DELETE_DATA_SOURCE = gql`
  mutation DeleteDataSource($id: ID!, $providerType: ProviderType!) {
    deleteDataSource(id: $id, providerType: $providerType)
  }
`;

const getProviderIcon = (providerType: string): string => {
  switch (providerType) {
    case 'GCP': return '/icons/google-cloud-icon-2048x1646-7admxejz.svg';
    case 'LANGFUSE': return '/icons/langfuse-icon.png';
    case 'AWS': return '/icons/aws.png';
    case 'AZURE': return '/icons/azure.svg';
    default: return '';
  }
};

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) { return 'N/A'; }
  const date = new Date(dateString);
  if (isNaN(date.getTime())) { return 'Invalid Date'; }

  const datePart = date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timePart = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${datePart} • ${timePart}`;
};

const getStatusChipSx = (status: string): SxProps<Theme> => {
    switch (status?.toLowerCase()) {
        case 'syncing': return { backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'rgba(255, 152, 0, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(255, 152, 0, 1)' };
        case 'valid': return { backgroundColor: 'rgba(3, 166, 90, 0.1)', color: 'rgba(3, 166, 90, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(3, 166, 90, 1)' };
        case 'invalid': return { backgroundColor: 'rgb(240, 213, 211)', color: 'rgba(202, 43, 32, 1)', fontWeight: 500, pointerEvents: 'none', border: '1px solid rgba(202, 43, 32, 1)' };
        default: return { backgroundColor: 'grey.200', color: 'grey.800', fontWeight: 500, border: '1px solid grey.400' };
    }
};

const DataSourcesPage: React.FC<DataSourcesPageProps> = ({ currentTenant }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { userRole } = useOutletContext<{ userRole?: string }>();

  const [isValidationPanelOpen, setIsValidationPanelOpen] = useState(false);
  const handleOpenValidationPanel = () => { setIsValidationPanelOpen(true); };
  const handleCloseValidationPanel = () => { setIsValidationPanelOpen(false); };

  const [columnVisibility, setColumnVisibility] = useState<ColumnVisibilityState>({
      dataSourceName: true, cloudProvider: true, status: true,
      lastModifiedBy: true, lastValidated: true, addedBy: true, addedOn: true,
  });
  const [tempColumnVisibility, setTempColumnVisibility] = useState<ColumnVisibilityState>(columnVisibility);
  const [columnMenuAnchorEl, setColumnMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isColumnMenuOpen = Boolean(columnMenuAnchorEl);

  const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
  const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedDataSource, setSelectedDataSource] = useState<AnyDataSource | null>(null);
  const isActionMenuOpen = Boolean(actionMenuAnchorEl);

  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const [isLoadingValidation, setIsLoadingValidation] = useState(false);
  const [validationError, setValidationError] = useState(false);

  const validationButtonRef = useRef<HTMLButtonElement>(null);
  const [showValidationPopover, setShowValidationPopover] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [providerMenuAnchorEl, setProviderMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isProviderMenuOpen = Boolean(providerMenuAnchorEl);

  const [providerFilters, setProviderFilters] = useState<string[]>([]);
  const [tempProviderFilters, setTempProviderFilters] = useState<string[]>([]);
  
  // --- CHANGE 2: Added a display name helper to show 'LLM' in the UI ---
  const getProviderDisplayName = (providerType: string) => {
    if (providerType === 'LANGFUSE') return 'LANGFUSE';
    return providerType;
  };

  const handleProviderMenuOpen = (event: React.MouseEvent<HTMLElement>) => { setTempProviderFilters(providerFilters); setProviderMenuAnchorEl(event.currentTarget); };
  const handleProviderMenuClose = () => setProviderMenuAnchorEl(null);
  const handleApplyProvider = () => { setProviderFilters(tempProviderFilters); handleProviderMenuClose(); };
  const handleClearProvider = () => { setTempProviderFilters([]); setProviderFilters([]); handleProviderMenuClose(); };
  const handleProviderCheckboxChange = (provider: string) => { setTempProviderFilters(prev => prev.includes(provider) ? prev.filter(p => p !== provider) : [...prev, provider]); };

  const { loading, error, data, refetch } = useQuery<{ allDataSourcesByTenant: AnyDataSource[] }>(
    GET_ALL_DATA_SOURCES_BY_TENANT,
    { variables: { tenantId: currentTenant?.id }, skip: !currentTenant?.id, fetchPolicy: 'network-only' }
  );

  const fetchValidationData = useCallback(async () => {
    setIsLoadingValidation(true);
    setValidationError(false);
    try { await refetch(); }
    catch (err) { console.error("Failed to refetch validation data:", err); setValidationError(true); }
    finally { setIsLoadingValidation(false); }
  }, [refetch]);

  useEffect(() => { if (isValidationPanelOpen) { fetchValidationData(); } }, [isValidationPanelOpen, fetchValidationData]);

  const [deleteDataSource, { loading: deleteLoading }] = useMutation(DELETE_DATA_SOURCE);

  const allDataSources = data?.allDataSourcesByTenant || [];

  const syncingCount = useMemo(() => allDataSources.filter(ds => ds.__typename === 'DataSource' && ds.isSyncing).length, [allDataSources]);
  const validCount = useMemo(() => allDataSources.filter(ds => (ds.__typename === 'DataSource' && !ds.isSyncing && ds.validationStatus === 'Valid') || ds.__typename === 'LlmDataSource').length, [allDataSources]);
  const invalidCount = useMemo(() => allDataSources.filter(ds => ds.__typename === 'DataSource' && !ds.isSyncing && ds.validationStatus === 'Invalid').length, [allDataSources]);

  useEffect(() => {
    const hasDismissed = sessionStorage.getItem('validationPopoverDismissed') === 'true';
    if (!loading && invalidCount > 0 && !hasDismissed) { setShowValidationPopover(true); }
  }, [loading, invalidCount]);

  const handleDismissValidationPopover = () => { setShowValidationPopover(false); sessionStorage.setItem('validationPopoverDismissed', 'true'); };
  useEffect(() => { if (location.state?.dataSourceAdded) { setToastMessage("Data source added successfully"); setToastOpen(true); navigate(location.pathname, { replace: true, state: {} }); } }, [location, navigate]);
  useEffect(() => { if (currentTenant) { refetch(); } }, [currentTenant, refetch]);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');
  const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isStatusMenuOpen = Boolean(statusMenuAnchorEl);
  const [tempStatusFilter, setTempStatusFilter] = useState('All');

  // --- CHANGE 3: Updated filtering logic to map the 'LLM' UI filter to the 'LANGFUSE' data type ---
  const filteredData = useMemo(() => {
    return allDataSources.filter(ds => {
      const matchesSearch = ds.name.toLowerCase().includes(searchTerm.toLowerCase());
      
      const mappedProviderFilters = providerFilters.map(f => f === 'LANGFUSE' ? 'LANGFUSE' : f);
      const matchesProvider = mappedProviderFilters.length === 0 || mappedProviderFilters.includes(ds.providerType);

      if (statusFilter === 'All') { return matchesSearch && matchesProvider; }

      let currentStatus: string;
      if (ds.__typename === 'DataSource') { currentStatus = ds.isSyncing ? 'Syncing' : ds.validationStatus; }
      else { currentStatus = 'Valid'; }
      const matchesStatus = currentStatus === statusFilter;

      return matchesSearch && matchesStatus && matchesProvider;
    });
  }, [allDataSources, searchTerm, statusFilter, providerFilters]);

  const pageCount = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = useMemo(() => filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage), [filteredData, page, rowsPerPage]);
  const showingFrom = filteredData.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
  const showingTo = Math.min(page * rowsPerPage, filteredData.length);

  const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => { setRowsPerPage(event.target.value as number); setPage(1); };
  const handleNextPage = () => setPage((prevPage) => Math.min(prevPage + 1, pageCount));
  const handlePreviousPage = () => setPage((prevPage) => Math.max(prevPage - 1, 1));
  const handleAddDataSourceClick = () => { if (currentTenant?.id) { navigate('/data-sources/add', { state: { tenantId: currentTenant.id } }); } else { alert("Please select a tenant before adding a data source."); } };
  const handleColumnSelectorClick = (event: React.MouseEvent<HTMLElement>) => { setTempColumnVisibility(columnVisibility); setColumnMenuAnchorEl(event.currentTarget); };
  const handleColumnSelectorClose = () => setColumnMenuAnchorEl(null);
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => { setTempColumnVisibility({ ...tempColumnVisibility, [event.target.name]: event.target.checked }); };
  const handleApplyColumns = () => { setColumnVisibility(tempColumnVisibility); handleColumnSelectorClose(); };
  const handleResetColumns = () => { const newVisibilityState: Partial<ColumnVisibilityState> = {}; allColumns.forEach(column => { newVisibilityState[column.id as keyof ColumnVisibilityState] = true; }); setTempColumnVisibility(newVisibilityState as ColumnVisibilityState); };
  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, dataSource: AnyDataSource) => { event.stopPropagation(); setActionMenuAnchorEl(event.currentTarget); setSelectedDataSource(dataSource); };
  const handleMenuClose = () => setActionMenuAnchorEl(null);
  const handlePanelClose = () => { setIsPanelOpen(false); setHoveredRowId(null); };
  const handleEdit = () => { if (selectedDataSource) { navigate(`/data-sources/edit/${selectedDataSource.id}`); } handleMenuClose(); };
  const handleDelete = () => { setIsDeleteDialogOpen(true); handleMenuClose(); };
  const handleCloseDeleteDialog = () => setIsDeleteDialogOpen(false);

  const handleConfirmDelete = async () => {
    if (!selectedDataSource) return;
    try {
      await deleteDataSource({ variables: { id: selectedDataSource.id, providerType: selectedDataSource.providerType } });
      setToastMessage(`Data source "${selectedDataSource.name}" deleted successfully.`);
      setToastOpen(true);
      refetch();
      handleCloseDeleteDialog();
    } catch (err) {
      console.error("Failed to delete data source:", err);
      handleCloseDeleteDialog();
    }
  };

  const handleStatusMenuOpen = (event: React.MouseEvent<HTMLElement>) => { setTempStatusFilter(statusFilter); setStatusMenuAnchorEl(event.currentTarget); };
  const handleStatusMenuClose = () => setStatusMenuAnchorEl(null);
  const handleApplyStatus = () => { setStatusFilter(tempStatusFilter); handleStatusMenuClose(); };
  const handleClearStatus = () => { setTempStatusFilter('All'); setStatusFilter('All'); handleStatusMenuClose(); };
  const handleClearAllFilters = () => { setStatusFilter('All'); setProviderFilters([]); setTempStatusFilter('All'); setTempProviderFilters([]); };

  const CustomValidationBadge = styled(Badge)(({ theme }) => ({ '& .MuiBadge-badge': { backgroundColor: ' rgba(202, 43, 32, 1)', color: '#FF9900', fontsize:'12px', mr:"12px" } }));
  const getProviderButtonText = () => {
    const count = providerFilters.length;
    const totalProviders = 4;
    if (count === 0) return 'Provider';
    if (count === totalProviders) return 'All';
    return providerFilters.join(' & ');
  };

  if (!currentTenant) return ( <Box sx={{ p: '24px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><Typography variant="h6" fontFamily={'Inter'}  color="text.secondary">Please select a tenant...</Typography><Button onClick={() => navigate('/dashboard')} sx={{ mt: '16px' }}>Go to Dashboard</Button></Box> );
  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: '24px', height: '100%' }}><CircularProgress /></Box>;
  if (!error && allDataSources.length === 0) return ( <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%', p: { xs: '8px', sm: '16px', md: '24px' } }}><Box sx={{ backgroundColor: 'white', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', p: { xs: '16px', sm: '24px', md: '32px' } }}><Box component="img" src="/icons/No-data-src-added-log.svg" alt="No data sources" sx={{ width: '143px', height: '143px' }} /><Typography variant="h5" component="h1" sx={{ fontWeight: 600, fontSize: '18px', mt: '16px', mb: '12px' }}>No data sources are added yet</Typography><Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '480px', fontSize: '14px', mb: '16px' }}>Click the button below to add data sources...</Typography>{userRole !== 'viewer' && (<Button disableElevation variant="contained" onClick={handleAddDataSourceClick} sx={{fontFamily:'Inter', backgroundColor:'#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}>Add New Data Source</Button>)}</Box></Box>);

  return (
    <Box sx={{ p: { xs: '16px', sm: '24px' }, display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', boxSizing: 'border-box' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px', flexShrink: 0 }}>
         <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
           <Typography variant="h6" sx={{ fontSize:'14px', fontWeight: 600 ,mb:-1.3}}>Data Sources ({allDataSources.length})</Typography>
            <Typography variant="body2" sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: '#666666' }}>Add and manage the connections to your data source providers to enable cost reporting.</Typography>
           <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
             <Chip icon={ <FiberManualRecordIcon sx={{ fill: theme.palette.success.main, width: '10px', height: '10px' }} /> } label={`Valid Data Sources ${validCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(232, 245, 233, 1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />
             <Chip icon={ <FiberManualRecordIcon sx={{ fill: '#CA2B20', width: '10px', height: '10px' }} /> } label={`Invalid Data Sources ${invalidCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(202, 43, 32, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none'}} />
             {syncingCount > 0 && (<Chip icon={ <FiberManualRecordIcon sx={{ fill: 'rgba(255, 152, 0, 1)', width: '10px', height: '10px' }} /> } label={`Syncing Data Sources ${syncingCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />)}
           </Box>
         </Box>
         {userRole !== 'viewer' && (<Button onClick={handleAddDataSourceClick} sx={{ backgroundColor:'#0064FF', width:'179px',height:'36px', textTransform: 'none', fontSize:'14px', fontWeight: 500, borderRadius: '8px',color:' #FFFFFF' }}>Add New Data Source</Button>)}
       </Box>

       <Paper elevation={0} sx={{ p: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', borderRadius: '12px', flexShrink: 0 }}>
          <TextField variant="outlined" size="small" placeholder="Search by data source name..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} sx={{ minWidth: { xs: '10px', sm: '250px' }, '& .MuiOutlinedInput-root': { borderRadius: '10px', fontFamily: 'Inter', fontSize: '14px', height: '32px', backgroundColor: 'var(--black-4, rgba(0, 0, 0, 0.04))', color: '#999999', fontWeight: '300', '& fieldset': { border: 0 } }, '& .MuiInputBase-input::placeholder': { opacity: 1, fontWeight:300, fontSize: '14px', color: '#999999' } }} InputProps={{ startAdornment: ( <InputAdornment position="start"><img src="/icons/search_icon.svg" alt="Search" width="17px" height="17px" /></InputAdornment>)}}/>
        <IconButton onClick={handleColumnSelectorClick} sx={{ p: 0 }}><img src={isColumnMenuOpen ? "/icons/Column_selector_active.svg" : "/icons/Column_selector.svg"} alt="Column Selector" width="32" height="32" /></IconButton>
        <Button id="status-filter-button" aria-controls={isStatusMenuOpen ? 'status-filter-menu' : undefined} aria-haspopup="true" aria-expanded={isStatusMenuOpen ? 'true' : undefined} variant="contained" onClick={handleStatusMenuOpen} endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isStatusMenuOpen ? 'rotate(180deg)' : 'none' }} />} sx={{ textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px', borderRadius: '8px', boxShadow: 'none', border: '1px solid', borderColor: isStatusMenuOpen || statusFilter !== 'All' ? '#0064FF' : theme.palette.divider, backgroundColor: isStatusMenuOpen || statusFilter !== 'All' ? '#F3F8FE' : 'transparent', '&:hover': { boxShadow: 'none', borderColor: '#0064FF' } }}>
          {statusFilter === 'All' ? (<Typography component="span" sx={{ fontSize: '14px' }}>Status</Typography>) : (<Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}><Typography component="span" sx={{ fontSize: '14px', fontWeight: 500  }}>Status:</Typography><Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{statusFilter}</Typography></Box>)}
        </Button>
        <Menu id="status-filter-menu" anchorEl={statusMenuAnchorEl} open={isStatusMenuOpen} onClose={handleStatusMenuClose} MenuListProps={{ 'aria-labelledby': 'status-filter-button', sx: { p: 0 } }} PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}>
            <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Select Status</Typography></Box>
            <Divider />
            <Box sx={{ py: '8px' }}>
                <RadioGroup value={tempStatusFilter} onChange={(e) => setTempStatusFilter(e.target.value)}>
                    <FormControlLabel value="Syncing" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Syncing" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Syncing' && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Syncing' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
                    <FormControlLabel value="Valid" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Valid" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Valid' && { backgroundColor: '#F3F8FE'}) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Valid' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
                    <FormControlLabel value="Invalid" control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />} label="Invalid" sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Invalid' && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Invalid' ? '#333333' : '#666666', fontSize: '14px' } } }}/>
                </RadioGroup>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}><Button onClick={handleClearStatus} sx={{ textTransform: 'none', fontSize:'14px', color: tempStatusFilter === 'All' ? '#7B7B7B' : '#333333', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button><Button onClick={handleApplyStatus} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button></Box>
        </Menu>
        <Button id="provider-filter-button" aria-controls={isProviderMenuOpen ? 'provider-filter-menu' : undefined} aria-haspopup="true" aria-expanded={isProviderMenuOpen ? 'true' : undefined} variant="contained" onClick={handleProviderMenuOpen} endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isProviderMenuOpen ? 'rotate(180deg)' : 'none' }} />} sx={{ textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px', borderRadius: '8px', boxShadow: 'none', border: '1px solid', borderColor: isProviderMenuOpen || providerFilters.length > 0 ? '#0064FF' : theme.palette.divider, backgroundColor: isProviderMenuOpen || providerFilters.length > 0 ? '#F3F8FE' : 'transparent', '&:hover': { boxShadow: 'none', borderColor: '#0064FF' }, }}>
          {providerFilters.length === 0 ? (<Typography component="span" sx={{ fontSize: '14px' }}>Provider</Typography>) : (<Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}><Typography component="span" sx={{ fontSize: '14px', fontWeight:500 }}>Provider:</Typography><Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{getProviderButtonText()}</Typography></Box>)}
        </Button>
        <Menu id="provider-filter-menu" anchorEl={providerMenuAnchorEl} open={isProviderMenuOpen} onClose={handleProviderMenuClose} MenuListProps={{ 'aria-labelledby': 'provider-filter-button', sx: { p: 0 } }} PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}>
            <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Select Provider</Typography></Box>
            <Divider />
            <Box sx={{ py: '10px' }}>
                <FormGroup>
                    {/* --- CHANGE 4: Updated provider filter UI to show 'LLM' --- */}
                    {[ {value: 'GCP', icon: '/icons/google-cloud-icon-2048x1646-7admxejz.svg'}, {value: 'LANGFUSE', icon: '/icons/langfuse-icon.png'}, {value: 'AWS', icon: '/icons/aws.svg'}, {value: 'AZURE', icon: '/icons/azure-1.svg'} ].map(p =>
                        <FormControlLabel key={p.value} control={ <Checkbox checked={tempProviderFilters.includes(p.value)} onChange={() => handleProviderCheckboxChange(p.value)} size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} /> } label={ <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={p.icon} alt={p.value} style={{ height: p.value === 'GCP' ? 27 : 20, width: p.value === 'GCP' ? 21: 20, marginRight: 8 }} />{p.value}</Box> } sx={{ width: '100%', m: 0, px: '1px',pl:'6px', py: '4px', ...(tempProviderFilters.includes(p.value) && { backgroundColor: '#F3F8FE' }) }} componentsProps={{ typography: { sx: { color: tempProviderFilters.includes(p.value) ? '#333333' : '#666666', fontSize: '14px' } } }}/>
                    )}
                </FormGroup>
            </Box>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}><Button onClick={handleClearProvider} sx={{ textTransform: 'none', fontSize:'14px', color: tempProviderFilters.length > 0 ? '#333333' : '#7B7B7B', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button><Button onClick={handleApplyProvider} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button></Box>
        </Menu>

        <Divider orientation="vertical" flexItem sx={{ mx: 1, my: '4px' }} />
        <Button onClick={handleClearAllFilters} sx={{ textTransform: 'none', fontSize: '14px', fontWeight: 500, color: (statusFilter !== 'All' || providerFilters.length > 0) ? '#0064FF' : '#7B7B7B' }}>Clear Filter</Button>
        <Box sx={{ flexGrow: 1 }} />
        <CustomValidationBadge variant="dot" invisible={invalidCount === 0} sx={{ "& .MuiBadge-badge": { transform: 'translate(175px, -19px)' } }} />
            <Button ref={validationButtonRef} variant="contained" onClick={handleOpenValidationPanel} startIcon={<img src="/icons/validation-r.svg" alt="Validation Icon" style={{ width: '12.14px', height: '11.28px' }} />} sx={{ textTransform: 'none', fontWeight: 500, fontSize:'14px', bgcolor: 'rgba(247, 247, 247, 1)', color: 'text.primary', boxShadow: 'none', '&:hover': { boxShadow: 'none' }, borderRadius: '8px' }}>Validation Result</Button>
      </Paper>

      <Paper elevation={0} sx={{ width: '100%', flexGrow: 1, display: 'flex', flexDirection: 'column', borderRadius: '8px', overflow: 'hidden' }}>
         {error ? <ErrorDSTableDisplay onRefresh={() => refetch()} /> : (
            <>
                <Box sx={{position: 'relative', flexGrow: 1 }}>
                    <TableContainer>
                        <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
                            <TableHead>
                                <TableRow sx={{ '& .MuiTableCell-root': { borderBottom: 'none', paddingTop: '30px' } }}>
                                    {allColumns.map(col => columnVisibility[col.id as keyof ColumnVisibilityState] && <TableCell key={col.id} sx={{ width: col.id === 'dataSourceName' ? '15%' : col.id === 'cloudProvider' ? '10%' : col.id === 'status' ? '9%' : 'auto', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px', fontWeight: 500, color: '#666666' }}>{col.label}</TableCell>)}
                                    <TableCell sx={{ width: '60px' }} />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.map((row, index) => (
                                    <TableRow key={row.id} onClick={() => { setSelectedDataSource(row); setIsPanelOpen(true); }} onMouseEnter={() => setHoveredRowId(row.id)} onMouseLeave={() => setHoveredRowId(null)} sx={{ cursor: 'pointer', '& td, & th': { border: 0, padding: '18px', height: '75px' }, backgroundColor: isPanelOpen && selectedDataSource?.id === row.id ? 'rgba(242, 247, 255, 1)' : (index % 2 !== 0 ? 'transparent' : '#F9FAFB'), '&:hover': { backgroundColor: 'rgba(242, 247, 255, 1)' } }}>
                                        {columnVisibility.dataSourceName && <TableCell component="th" scope="row" sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.name}</TableCell>}
                                        
                                        {columnVisibility.status && (
                                            <TableCell>
                                                {row.__typename === 'DataSource' ? (<Chip label={row.isSyncing ? 'Syncing' : row.validationStatus} size="small" sx={getStatusChipSx(row.isSyncing ? 'Syncing' : row.validationStatus)}/>) : (<Chip label="Valid" size="small" sx={getStatusChipSx('Valid')}/>)}
                                            </TableCell>
                                        )}
                                        {/* --- CHANGE 5: Used the display name helper for the provider column --- */}
                                        {columnVisibility.cloudProvider && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}><img src={getProviderIcon(row.providerType)} alt={row.providerType} style={{ width: '20px', height: '20px' }} />{getProviderDisplayName(row.providerType)}</Box></TableCell>}
                                        
                                        {columnVisibility.lastModifiedBy && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}><Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>{!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}</Avatar>{row.creator.name}</Box></TableCell>}
                                        
                                        {columnVisibility.lastValidated && <TableCell sx={{ whiteSpace: 'nowrap' }}>{row.__typename === 'DataSource' ? formatDate(row.lastValidatedAt) : formatDate(row.createdAt)}</TableCell>}
                                        
                                        {columnVisibility.addedBy && <TableCell><Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}><Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>{!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}</Avatar>{row.creator.name}</Box></TableCell>}
                                        {columnVisibility.addedOn && <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(row.createdAt)}</TableCell>}
                                        <TableCell>
                                            {userRole !== 'viewer' && (<IconButton aria-label="actions" onClick={(event) => handleMenuOpen(event, row)} sx={{ visibility: hoveredRowId === row.id || (isActionMenuOpen && selectedDataSource?.id === row.id) ? 'visible' : 'hidden', width: '32px', height: '32px', backgroundColor: '#FFFFFF', border: ' rgb(203, 203, 203) solid 1px', borderRadius: '8px', '&:hover': { backgroundColor: '#F5F5F5' } }}><MoreHorizIcon sx={{ width: '18px', height: 'auto', color: '#333333' }} /></IconButton>)}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, minHeight: '56px', padding: '0 24px', backgroundColor: '#FFFFFF' }}>
                    <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary' }}>Rows per page:</Typography>
                    <FormControl size="small"><Select value={rowsPerPage} onChange={handleRowsPerPageChange} sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', '.MuiOutlinedInput-notchedOutline': { border: 'none' }, '.MuiSelect-select': { padding: '4px 8px' } }}><MenuItem value={6}>6</MenuItem><MenuItem value={10}>10</MenuItem><MenuItem value={25}>25</MenuItem></Select></FormControl>
                    <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', fontWeight: 500 }}>{showingFrom} – {showingTo} of {filteredData.length}</Typography>
                    <IconButton onClick={handlePreviousPage} disabled={page === 1} aria-label="previous page"><ArrowBackIosNewIcon sx={{ fontSize: '16px' }} /></IconButton>
                    <IconButton onClick={handleNextPage} disabled={page >= pageCount} aria-label="next page"><ArrowForwardIosIcon sx={{ fontSize: '16px' }} /></IconButton>
                </Box>
            </>
        )}
      </Paper>
      <Drawer anchor="right" open={isPanelOpen} onClose={handlePanelClose} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} PaperProps={{ sx: { borderRadius: '12px', margin: '20px', height: 'calc(100% - 40px)', width: '500px' } }}>
        <DataSourceDetailPanel dataSourceId={selectedDataSource?.id || null} onClose={handlePanelClose} />
      </Drawer>
      <Menu anchorEl={columnMenuAnchorEl} open={isColumnMenuOpen} onClose={handleColumnSelectorClose} MenuListProps={{ 'aria-labelledby': 'column-selector-button', sx: { p: 0 } }} PaperProps={{ sx: { width: '280px', borderRadius: '8px', boxShadow: theme.shadows[2], mt: '8px', overflow: 'hidden' } }}>
        <Box sx={{ px: '16px', pt: '12px', pb: '8px',borderBottom: `1px solid ${theme.palette.divider}` }}><Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Column selector</Typography></Box>
        {allColumns.map((column) => {
          const isChecked = tempColumnVisibility[column.id as keyof typeof tempColumnVisibility] || false;
          const getBackgroundColor = () => isChecked ? (column.locked ? '#F9FAFB' : 'rgba(237, 246, 255, 1)') : '#FFFFFF';
          const getHoverBackgroundColor = () => isChecked ? (column.locked ? '#F0F2F5' : 'rgba(220, 235, 255, 1)') : theme.palette.action.hover;
          return (<MenuItem key={column.id} onClick={() => { if (!column.locked) { handleCheckboxChange({ target: { name: column.id, checked: !isChecked } } as React.ChangeEvent<HTMLInputElement>); } }} disableRipple sx={{ py: '10px', px: '20px', cursor: column.locked ? 'not-allowed' : 'pointer', backgroundColor: getBackgroundColor(), borderBottom: '4px solid #FFFFFF', '&:last-of-type': { borderBottom: 'none' }, '&:hover': { backgroundColor: getHoverBackgroundColor() } }}><Checkbox checked={isChecked} disabled={column.locked} size="small" sx={{ p: 0, mr: '12px', pointerEvents: 'none', color: column.locked ? theme.palette.action.disabled : undefined, '&.Mui-checked': { color: column.locked ? theme.palette.grey[600] : '#0064FF' } }} /><ListItemText primary={column.label} sx={{ flexGrow: 1, '& .MuiListItemText-primary': { fontWeight: 400, fontSize: '14px', color: column.locked ? ' #666666' : ' #333333' } }} />{column.locked && <img src="/icons/lock-icon.svg" alt="Locked" style={{ width: '16px', height: '16px', marginLeft: '8px', opacity: 0.5 }} />}</MenuItem>);
        })}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px', borderTop: `1px solid ${theme.palette.divider}`, alignItems: 'center' }}><Button onClick={handleResetColumns} sx={{ marginRight:'-10px',fontWeight: 500, fontSize: '14px', textTransform: 'none', color:' #7B7B7B' }}>Reset</Button><Button onClick={handleApplyColumns} sx={{ fontWeight: 500, fontSize: '14px', textTransform: 'none', color: ' #0064FF' }}>Apply</Button></Box>
      </Menu>

      <SuccessToast open={toastOpen} message={toastMessage} onClose={() => setToastOpen(false)} />
      <Menu anchorEl={actionMenuAnchorEl} open={isActionMenuOpen} onClose={handleMenuClose} PaperProps={{ sx: { borderRadius: '8px', width: '200px' } }}>
        <MenuItem onClick={handleEdit}><ListItemIcon><img src="/icons/edit_icon.svg" alt="Edit" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon><ListItemText>Edit</ListItemText></MenuItem>
        <Divider />
        <MenuItem onClick={handleDelete} ><ListItemIcon><img src="/icons/delete_icon.svg" alt="Delete" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon><ListItemText sx={{ color:' #CA2B20', fontWeight:400 , fontSize:'14px'}} >Delete</ListItemText></MenuItem>
      </Menu>

      <Drawer anchor="right" open={isValidationPanelOpen} onClose={handleCloseValidationPanel} sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} PaperProps={{ sx: { borderRadius: '12px', margin: '20px', height: 'calc(100% - 40px)', width: '500px' } }}>
        <ValidationResultPanel onClose={handleCloseValidationPanel} dataSources={filteredData.filter(ds => ds.__typename === 'DataSource') as unknown as ValidationDataSource[]} loading={isLoadingValidation} error={validationError} onRefresh={fetchValidationData} />
      </Drawer>
      
      {/* This now passes the correctly typed 'selectedDataSource' to the dialog, resolving the error */}
      <DeleteDataSourceDialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog} onConfirm={handleConfirmDelete} dataSource={selectedDataSource} isDeleting={deleteLoading} />
      
      <Popover open={showValidationPopover} anchorEl={validationButtonRef.current} onClose={handleDismissValidationPopover} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} transformOrigin={{ vertical: 'bottom', horizontal: 'center' }} PaperProps={{ sx: { p: 2, mt: 26, ml: 67, borderRadius: '12px', bgcolor: 'rgba(225, 239, 255, 1)', boxShadow: '0px 5px 15px rgba(0,0,0,0.1)', '&::after': { content: '""', position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)', borderWidth: '8px', borderStyle: 'solid', borderColor: 'transparent transparent rgba(225, 239, 255, 1) transparent', marginRight:'100px' } } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: 300 }}><Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 1 }}>Validation issues</Typography><Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>Some data sources have validation issues. View the results to address them.</Typography><Button onClick={handleDismissValidationPopover} sx={{ alignSelf: 'flex-end', fontWeight: 600, textTransform: 'none' }}>Got It</Button></Box>
      </Popover>
    </Box>
  );
};

export default DataSourcesPage;








// // import React, { useState, useMemo, useEffect, useRef } from 'react';
// import { Box, Typography, Button, TextField, InputAdornment, Paper, Avatar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Select, MenuItem, FormControl, Alert, useTheme, Divider, Menu, Checkbox, FormControlLabel, IconButton, ListItemIcon, ListItemText, Drawer, RadioGroup, Radio, Badge, Popover, SelectChangeEvent, FormGroup } from '@mui/material';
// import { gql, useQuery, useMutation } from '@apollo/client';
// import { useNavigate, useLocation, useOutletContext} from 'react-router-dom';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
// import {
//     FiberManualRecord as FiberManualRecordIcon,
//     Tune as TuneIcon,
//     KeyboardArrowDown as KeyboardArrowDownIcon,
//     MoreHoriz as MoreHorizIcon,
// } from '@mui/icons-material';
// import { styled } from '@mui/material/styles';
// import SuccessToast from '../../SuccessToast';
// import DataSourceDetailPanel from './DataSourceDetailPanel';
// import DeleteDataSourceDialog from './DeleteDataSourceDialog';
// import ValidationResultPanel, { ValidationDataSource } from './ValidationResultPanel';
// import { Chip, SxProps, Theme } from '@mui/material'; // <--- Ensure SxProps and Theme are imported
// // Add this line with your other imports
// import ErrorDSTableDisplay from './Error-DS-table-Display'; // Make sure the path is correct

// export interface Tenant {
//   id: string;
//   name: string;
// }

// interface DataSource {
//   id: string;
//   name: string;
//   providerType: 'GCP' | 'AWS' | 'AZURE' | string;
//   validationStatus: 'Valid' | 'Invalid' | 'Pending' | string;
//   isSyncing: boolean;
//   lastValidatedAt: string | null;
//   createdAt: string;
//   creator: {
//     id: string;
//     name: string | null;
//     photo?: string | null;
//   };
// }

// type ColumnVisibilityState = {
//     dataSourceName: boolean;
//     cloudProvider: boolean;
//     status: boolean;
//     lastModifiedBy: boolean;
//     lastValidated: boolean;

//     addedBy: boolean;
//     addedOn: boolean;
// };

// interface DataSourcesPageProps {
//   currentTenant: Tenant | null;
// }

// const allColumns = [
//   { id: 'dataSourceName', label: 'Data Source Name', locked: true, draggable: false },
//   { id: 'status', label: 'Status', locked: true, draggable: false },
//   { id: 'cloudProvider', label: 'Cloud Provider', locked: false, draggable: false },
//   { id: 'lastModifiedBy', label: 'Last Modified By', locked: false, draggable: true },
//   { id: 'lastValidated', label: 'Last Validated', locked: false, draggable: false },
//   { id: 'addedBy', label: 'Added By', locked: false, draggable: false },
//   { id: 'addedOn', label: 'Added On', locked: false },
// ];

// const GET_DATA_SOURCES_BY_TENANT = gql`
//   query GetDataSourcesByTenant($tenantId: ID!) {
//     dataSourcesByTenant(tenantId: $tenantId) {
//       id
//       name
//       providerType
//       validationStatus
//       isSyncing
//       lastValidatedAt
//       createdAt
//       billingAccountId
//       validationErrors
//       creator {
//         id
//         name
//         photo
//       }
//     }
//   }
// `;

// const DELETE_DATA_SOURCE = gql`
//   mutation DeleteDataSource($id: ID!) {
//     deleteDataSource(id: $id) {
//       id
//     }
//   }
// `;

// const getProviderIcon = (providerType: string): string => {
//   switch (providerType) {
//     case 'GCP': return '/icons/google-cloud-icon-2048x1646-7admxejz.svg';
//     case 'AWS': return '/icons/aws.png';
//     case 'AZURE': return '/icons/azure.svg';
//     default: return '';
//   }
// };

// const formatDate = (dateString: string | null | undefined): string => {
//   if (!dateString) {
//     return 'N/A';
//   }

//   const date = new Date(dateString);

//   if (isNaN(date.getTime())) {
//     return 'Invalid Date';
//   }

//   const datePart = date.toLocaleDateString('en-GB', {
//     day: '2-digit',
//     month: '2-digit',
//     year: 'numeric',
//   });

//   let hours = date.getHours();
//   const minutes = date.getMinutes();
//   const ampm = hours >= 12 ? 'PM' : 'AM';
//   hours = hours % 12;
//   if (hours === 0) {
//     hours = 12;
//   }
//   const minutesStr = String(minutes).padStart(2, '0');
//   const timePart = `${hours}:${minutesStr} ${ampm}`;

//   return `${datePart} • ${timePart}`;
// };

// const getStatusChipSx = (status: string): SxProps<Theme> => {
//     switch (status?.toLowerCase()) {
//         case 'syncing':
//             return {
//                 backgroundColor: 'rgba(255, 193, 7, 0.1)',
//                 color: 'rgba(255, 152, 0, 1)',
//                 fontWeight: 500,
//                 pointerEvents: 'none',
//                 border: '1px solid rgba(255, 152, 0, 1)',
//             };
//         case 'valid':
//             return {
//                 backgroundColor: 'rgba(3, 166, 90, 0.1)',
//                 color: 'rgba(3, 166, 90, 1)',
//                 fontWeight: 500,
//                 pointerEvents: 'none',
//                 border: '1px solid rgba(3, 166, 90, 1)',
//             };
//         case 'invalid':
//             return {
//                 backgroundColor: 'rgb(240, 213, 211)',
//                 color: 'rgba(202, 43, 32, 1)',
//                 fontWeight: 500,
//                 pointerEvents: 'none',
//                 border: '1px solid rgba(202, 43, 32, 1)',
//             };
//         default:
//             return {
//                 backgroundColor: 'grey.200',
//                 color: 'grey.800',
//                 fontWeight: 500,
//                 border: '1px solid grey.400',
//             };
//     }
// };

// const DataSourcesPage: React.FC<DataSourcesPageProps> = ({ currentTenant }) => {
//   const theme = useTheme();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { userRole } = useOutletContext<{ userRole?: string }>();

//   const [isValidationPanelOpen, setIsValidationPanelOpen] = useState(false);
//   const handleOpenValidationPanel = () => { setIsValidationPanelOpen(true); };
//   const handleCloseValidationPanel = () => { setIsValidationPanelOpen(false); };

//   const [columnVisibility, setColumnVisibility] = useState<ColumnVisibilityState>({
//       dataSourceName: true, cloudProvider: true, status: true,
//       lastModifiedBy: true, lastValidated: true, addedBy: true, addedOn: true,
//   });
//   const [tempColumnVisibility, setTempColumnVisibility] = useState<ColumnVisibilityState>(columnVisibility);
//   const [columnMenuAnchorEl, setColumnMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isColumnMenuOpen = Boolean(columnMenuAnchorEl);

//   const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);
//   const [actionMenuAnchorEl, setActionMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const [selectedDataSource, setSelectedDataSource] = useState<DataSource | null>(null);
//   const isActionMenuOpen = Boolean(actionMenuAnchorEl);

//   const [toastOpen, setToastOpen] = useState(false);
//   const [toastMessage, setToastMessage] = useState('');
//   const [isPanelOpen, setIsPanelOpen] = useState(false);
//   const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

//   const [isLoadingValidation, setIsLoadingValidation] = useState(false);
//   const [validationError, setValidationError] = useState(true);

//   const validationButtonRef = useRef<HTMLButtonElement>(null);
//   const [showValidationPopover, setShowValidationPopover] = useState(false);

//   const [page, setPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(6);
//   const [providerMenuAnchorEl, setProviderMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isProviderMenuOpen = Boolean(providerMenuAnchorEl);

//   const [providerFilters, setProviderFilters] = useState<string[]>([]);
//   const [tempProviderFilters, setTempProviderFilters] = useState<string[]>([]);

//   const handleProviderMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
//     setTempProviderFilters(providerFilters);
//     setProviderMenuAnchorEl(event.currentTarget);
//   };

//   const handleProviderMenuClose = () => {
//     setProviderMenuAnchorEl(null);
//   };

//   const handleApplyProvider = () => {
//     setProviderFilters(tempProviderFilters);
//     handleProviderMenuClose();
//   };

//   const handleClearProvider = () => {
//     setTempProviderFilters([]);
//     setProviderFilters([]);
//     handleProviderMenuClose();
//   };

//   const handleProviderCheckboxChange = (provider: string) => {
//     setTempProviderFilters(prev =>
//         prev.includes(provider)
//             ? prev.filter(p => p !== provider)
//             : [...prev, provider]
//     );
//   };

//   const { loading, error, data, refetch } = useQuery<{ dataSourcesByTenant: DataSource[] }>(
//     GET_DATA_SOURCES_BY_TENANT,
//     {
//       variables: { tenantId: currentTenant?.id },
//       skip: !currentTenant?.id,
//       fetchPolicy: 'network-only',
//     }
//   );

//   const fetchValidationData = useCallback(async () => {
//     setIsLoadingValidation(true);
//     setValidationError(false);
//     try {
//       await refetch();
//     } catch (err) {
//       console.error("Failed to refetch validation data:", err);
//       setValidationError(true);
//     } finally {
//       setIsLoadingValidation(false);
//     }
//   }, [refetch]);

//   useEffect(() => {
//     if (isValidationPanelOpen) {
//         fetchValidationData();
//     }
//   }, [isValidationPanelOpen, fetchValidationData]);

//   const [deleteDataSource, { loading: deleteLoading }] = useMutation(DELETE_DATA_SOURCE);

//   const dataSources = data?.dataSourcesByTenant || [];

//   const syncingCount = useMemo(() => {
//     if (!dataSources) return 0;
//     return dataSources.filter(ds => ds.isSyncing).length;
//   }, [dataSources]);

//   const validCount = useMemo(() => {
//     if (!dataSources) return 0;
//     return dataSources.filter(ds => !ds.isSyncing && ds.validationStatus === 'Valid').length;
//   }, [dataSources]);

//   const invalidCount = useMemo(() => {
//     if (!dataSources) return 0;
//     return dataSources.filter(ds => !ds.isSyncing && ds.validationStatus === 'Invalid').length;
//   }, [dataSources]);

//   useEffect(() => {
//     const hasDismissed = sessionStorage.getItem('validationPopoverDismissed') === 'true';
//     if (!loading && invalidCount > 0 && !hasDismissed) {
//       setShowValidationPopover(true);
//     }
//   }, [loading, invalidCount]);

//   const handleDismissValidationPopover = () => {
//     setShowValidationPopover(false);
//     sessionStorage.setItem('validationPopoverDismissed', 'true');
//   };

//   useEffect(() => {
//     if (location.state?.dataSourceAdded) {
//         setToastMessage("Data source added successfully");
//         setToastOpen(true);
//         navigate(location.pathname, { replace: true, state: {} });
//     }
//   }, [location, navigate]);

//   useEffect(() => { if (currentTenant) { refetch(); } }, [currentTenant, refetch]);

//   const [searchTerm, setSearchTerm] = useState('');
//   const [statusFilter, setStatusFilter] = useState('All');
//   const [statusMenuAnchorEl, setStatusMenuAnchorEl] = useState<null | HTMLElement>(null);
//   const isStatusMenuOpen = Boolean(statusMenuAnchorEl);
//   const [tempStatusFilter, setTempStatusFilter] = useState('All');

//   const filteredData = useMemo(() => {
//     if (!dataSources) return [];
//     return dataSources.filter(ds => {
//       const matchesSearch = ds.name.toLowerCase().includes(searchTerm.toLowerCase());
      
//       const getStatus = (dataSource: DataSource) => {
//         if (dataSource.isSyncing) return 'Syncing';
//         return dataSource.validationStatus;
//       }
//       const currentStatus = getStatus(ds);
//       const matchesStatus = statusFilter === 'All' || currentStatus === statusFilter;

//       const matchesProvider = providerFilters.length === 0 || providerFilters.includes(ds.providerType);
//       return matchesSearch && matchesStatus && matchesProvider;
//     });
//   }, [dataSources, searchTerm, statusFilter, providerFilters]);

//   const pageCount = Math.ceil(filteredData.length / rowsPerPage);
//   const paginatedData = useMemo(() => {
//       return filteredData.slice((page - 1) * rowsPerPage, page * rowsPerPage);
//   }, [filteredData, page, rowsPerPage]);
//   const showingFrom = filteredData.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
//   const showingTo = Math.min(page * rowsPerPage, filteredData.length);

//   const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
//     setRowsPerPage(event.target.value as number);
//     setPage(1);
//   };

//   const handleNextPage = () => {
//     setPage((prevPage) => Math.min(prevPage + 1, pageCount));
//   };

//   const handlePreviousPage = () => {
//     setPage((prevPage) => Math.max(prevPage - 1, 1));
//   };

//   const handleAddDataSourceClick = () => {
//     if (currentTenant?.id) {
//         navigate('/data-sources/add', {
//             state: { tenantId: currentTenant.id }
//         });
//     } else {
//         alert("Please select a tenant before adding a data source.");
//     }
//   };

//   const handleColumnSelectorClick = (event: React.MouseEvent<HTMLElement>) => {
//       setTempColumnVisibility(columnVisibility);
//       setColumnMenuAnchorEl(event.currentTarget);
//   };

//   const handleColumnSelectorClose = () => {
//       setColumnMenuAnchorEl(null);
//   };

//   const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//       setTempColumnVisibility({ ...tempColumnVisibility, [event.target.name]: event.target.checked });
//   };

//   const handleApplyColumns = () => {
//       setColumnVisibility(tempColumnVisibility);
//       handleColumnSelectorClose();
//   };

//   const handleResetColumns = () => {
//     const newVisibilityState: Partial<ColumnVisibilityState> = {};
//     allColumns.forEach(column => {
//         newVisibilityState[column.id as keyof ColumnVisibilityState] = true;
//     });
//     setTempColumnVisibility(newVisibilityState as ColumnVisibilityState);
//   };

//   const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, dataSource: DataSource) => {
//     event.stopPropagation();
//     setActionMenuAnchorEl(event.currentTarget);
//     setSelectedDataSource(dataSource);
//   };

//   const handleMenuClose = () => { setActionMenuAnchorEl(null); };

//   const handlePanelClose = () => {
//     setIsPanelOpen(false);
//     setHoveredRowId(null);
//   };

//   const handleEdit = () => {
//     if (selectedDataSource) {
//       navigate(`/data-sources/edit/${selectedDataSource.id}`);
//     }
//     handleMenuClose();
//   };

//   const handleDelete = () => {
//     setIsDeleteDialogOpen(true);
//     handleMenuClose();
//   };

//   const handleCloseDeleteDialog = () => {
//     setIsDeleteDialogOpen(false);
//   };

//   const handleConfirmDelete = async () => {
//     if (!selectedDataSource) return;
//     try {
//       await deleteDataSource({
//         variables: { id: selectedDataSource.id },
//       });
//       setToastMessage(`Data source "${selectedDataSource.name}" deleted successfully.`);
//       setToastOpen(true);
//       refetch();
//       handleCloseDeleteDialog();
//     } catch (err) {
//       console.error("Failed to delete data source:", err);
//       handleCloseDeleteDialog();
//     }
//   };

//   const handleStatusMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
//     setTempStatusFilter(statusFilter);
//     setStatusMenuAnchorEl(event.currentTarget);
//   };

//   const handleStatusMenuClose = () => {
//     setStatusMenuAnchorEl(null);
//   };

//   const handleApplyStatus = () => {
//     setStatusFilter(tempStatusFilter);
//     handleStatusMenuClose();
//   };

//   const handleClearStatus = () => {
//     setTempStatusFilter('All');
//     setStatusFilter('All');
//     handleStatusMenuClose();
//   };

//   const handleClearAllFilters = () => {
//     setStatusFilter('All');
//     setProviderFilters([]);
//     setTempStatusFilter('All');
//     setTempProviderFilters([]);
//   };

//   const CustomValidationBadge = styled(Badge)(({ theme }) => ({
//     '& .MuiBadge-badge': {
//       backgroundColor: ' rgba(202, 43, 32, 1)',
//       color: '#FF9900',
//       fontsize:'12px',
//       mr:"12px",
//     },
//   }));

//   const getProviderButtonText = () => {
//     const count = providerFilters.length;
//     const totalProviders = 3;

//     if (count === 0) return 'Provider';
//     if (count === totalProviders) return 'All';
//     return providerFilters.join(' & ');
//   };

//   if (!currentTenant) { return ( <Box sx={{ p: '24px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}><Typography variant="h6" fontFamily={'Inter'}  color="text.secondary">Please select a tenant...</Typography><Button onClick={() => navigate('/dashboard')} sx={{ mt: '16px' }}>Go to Dashboard</Button></Box> ); }
//   if (loading) { return <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: '24px', height: '100%' }}><CircularProgress /></Box>; }

//   if (!error && dataSources.length === 0) {
//     return (
//       <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%', p: { xs: '8px', sm: '16px', md: '24px' } }}>
//         <Box sx={{ backgroundColor: 'white', borderRadius: '10px', flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', p: { xs: '16px', sm: '24px', md: '32px' } }}>
//           <Box component="img" src="/icons/No-data-src-added-log.svg" alt="No data sources" sx={{ width: '143px', height: '143px' }} />
//           <Typography variant="h5" component="h1" sx={{ fontWeight: 600, fontSize: '18px', mt: '16px', mb: '12px' }}>No data sources are added yet</Typography>
//           <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: '480px', fontSize: '14px', mb: '16px' }}>Click the button below to add data sources...</Typography>
//           {userRole !== 'viewer' && (
//             <Button disableElevation variant="contained" onClick={handleAddDataSourceClick} sx={{fontFamily:'Inter', backgroundColor:'#0064FF', fontSize: '14px', fontWeight: 500, borderRadius: '8px', textTransform: 'none' }}>Add New Data Source</Button>
//           )}
//         </Box>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: { xs: '16px', sm: '24px' }, display: 'flex', flexDirection: 'column', gap: '16px', height: '100%', boxSizing: 'border-box' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '16px', flexShrink: 0 }}>
//          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
//            <Typography variant="h6" sx={{ fontSize:'14px', fontWeight: 600 ,mb:-1.3}}>Data Sources ({dataSources.length})</Typography>
//             <Typography variant="body2" sx={{ fontFamily: 'Inter', fontWeight: 400, fontSize: '12px', color: '#666666' }}>
//           Add and manage the connections to your cloud providers to enable cost reporting.       </Typography>
//            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
//              <Chip icon={ <FiberManualRecordIcon sx={{ fill: theme.palette.success.main, width: '10px', height: '10px' }} /> } label={`Valid Data Sources ${validCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(232, 245, 233, 1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />
//              <Chip icon={ <FiberManualRecordIcon sx={{ fill: '#CA2B20', width: '10px', height: '10px' }} /> } label={`Invalid Data Sources ${invalidCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(202, 43, 32, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none'}} />
//              {syncingCount > 0 && (
//                 <Chip icon={ <FiberManualRecordIcon sx={{ fill: 'rgba(255, 152, 0, 1)', width: '10px', height: '10px' }} /> } label={`Syncing Data Sources ${syncingCount}`} size="small" sx={{ gap:'4px', backgroundColor: 'rgba(255, 193, 7, 0.1)', color: 'rgba(102, 102, 102, 1)', fontWeight: 400, borderRadius: '14px', padding: '0px 8px', pointerEvents:'none' }} />
//              )}
//            </Box>
//          </Box>
//          {userRole !== 'viewer' && (
//            <Button  onClick={handleAddDataSourceClick} sx={{ backgroundColor:'#0064FF', width:'179px',height:'36px', textTransform: 'none', fontSize:'14px', fontWeight: 500, borderRadius: '8px',color:' #FFFFFF' }}>Add New Data Source</Button>
//          )}
//        </Box>

//        <Paper elevation={0} sx={{ p: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', borderRadius: '12px', flexShrink: 0 }}>
//           <TextField
//             variant="outlined"
//             size="small"
//             placeholder="Search by data source name..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             sx={{
//               minWidth: { xs: '10px', sm: '250px' },
//               '& .MuiOutlinedInput-root': {
//                 borderRadius: '10px', fontFamily: 'Inter', fontSize: '14px', height: '32px',
//                 backgroundColor: 'var(--black-4, rgba(0, 0, 0, 0.04))', color: '#999999',
//                 fontWeight: '300', '& fieldset': { border: 0 }
//               },
//               '& .MuiInputBase-input::placeholder': { opacity: 1, fontWeight:300, fontSize: '14px', color: '#999999' }
//             }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <img src="/icons/search_icon.svg" alt="Search" width="17px" height="17px" />
//                 </InputAdornment>
//               )
//             }}
//           />
//         <IconButton onClick={handleColumnSelectorClick} sx={{ p: 0 }}>
//           <img src={isColumnMenuOpen ? "/icons/Column_selector_active.svg" : "/icons/Column_selector.svg"} alt="Column Selector" width="32" height="32" />
//         </IconButton>
//         <Button
//             id="status-filter-button"
//             aria-controls={isStatusMenuOpen ? 'status-filter-menu' : undefined}
//             aria-haspopup="true"
//             aria-expanded={isStatusMenuOpen ? 'true' : undefined}
//             variant="contained"
//             onClick={handleStatusMenuOpen}
//             endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isStatusMenuOpen ? 'rotate(180deg)' : 'none' }} />}
//             sx={{
//                 textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px',
//                 borderRadius: '8px', boxShadow: 'none', border: '1px solid',
//                 borderColor: isStatusMenuOpen || statusFilter !== 'All' ? '#0064FF' : theme.palette.divider,
//                 backgroundColor: isStatusMenuOpen || statusFilter !== 'All' ? '#F3F8FE' : 'transparent',
//                 '&:hover': { boxShadow: 'none', borderColor: '#0064FF' },
//             }}
//         >
//           {statusFilter === 'All' ? (
//             <Typography component="span" sx={{ fontSize: '14px' }}>Status</Typography>
//            ) : (
//             <Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
//                 <Typography component="span" sx={{ fontSize: '14px', fontWeight: 500  }}>Status:</Typography>
//                 <Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{statusFilter}</Typography>
//             </Box>
//            )}
//         </Button>
//         <Menu
//             id="status-filter-menu"
//             anchorEl={statusMenuAnchorEl}
//             open={isStatusMenuOpen}
//             onClose={handleStatusMenuClose}
//             MenuListProps={{ 'aria-labelledby': 'status-filter-button', sx: { p: 0 } }}
//             PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}
//         >
//             <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>
//                   Select Status
//                 </Typography>
//             </Box>
//             <Divider />
//             <Box sx={{ py: '8px' }}>
//                 <RadioGroup value={tempStatusFilter} onChange={(e) => setTempStatusFilter(e.target.value)}>
//                     <FormControlLabel
//                         value="Syncing"
//                         control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                         label="Syncing"
//                         sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Syncing' && { backgroundColor: '#F3F8FE' }) }}
//                         componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Syncing' ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                     <FormControlLabel
//                         value="Valid"
//                         control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                         label="Valid"
//                         sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Valid' && { backgroundColor: '#F3F8FE'}) }}
//                         componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Valid' ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                     <FormControlLabel
//                         value="Invalid"
//                         control={<Radio size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} />}
//                         label="Invalid"
//                         sx={{ width: '100%', m: 0, px: '1px', py: '4px', ...(tempStatusFilter === 'Invalid' && { backgroundColor: '#F3F8FE' }) }}
//                         componentsProps={{ typography: { sx: { color: tempStatusFilter === 'Invalid' ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                 </RadioGroup>
//             </Box>
//             <Divider />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}>
//                 <Button onClick={handleClearStatus} sx={{ textTransform: 'none', fontSize:'14px', color: tempStatusFilter === 'All' ? '#7B7B7B' : '#333333', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button>
//                 <Button onClick={handleApplyStatus} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button>
//             </Box>
//         </Menu>
//         <Button
//             id="provider-filter-button"
//             aria-controls={isProviderMenuOpen ? 'provider-filter-menu' : undefined}
//             aria-haspopup="true"
//             aria-expanded={isProviderMenuOpen ? 'true' : undefined}
//             variant="contained"
//             onClick={handleProviderMenuOpen}
//             endIcon={<KeyboardArrowDownIcon sx={{ transition: 'transform 0.2s', transform: isProviderMenuOpen ? 'rotate(180deg)' : 'none' }} />}
//             sx={{
//                 textTransform: 'none', fontWeight: 400, color: 'text.primary', height: '32px',
//                 borderRadius: '8px', boxShadow: 'none', border: '1px solid',
//                 borderColor: isProviderMenuOpen || providerFilters.length > 0 ? '#0064FF' : theme.palette.divider,
//                 backgroundColor: isProviderMenuOpen || providerFilters.length > 0 ? '#F3F8FE' : 'transparent',
//                 '&:hover': { boxShadow: 'none', borderColor: '#0064FF' },
//             }}
//         >
//           {providerFilters.length === 0 ? (
//             <Typography component="span" sx={{ fontSize: '14px' }}>Provider</Typography>
//            ) : (
//             <Box component="span" sx={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
//                 <Typography component="span" sx={{ fontSize: '14px', fontWeight:500 }}>Provider:</Typography>
//                 <Typography component="span" sx={{ fontSize: '14px', fontWeight: 400 }}>{getProviderButtonText()}</Typography>
//             </Box>
//            )}
//         </Button>
//         <Menu
//             id="provider-filter-menu"
//             anchorEl={providerMenuAnchorEl}
//             open={isProviderMenuOpen}
//             onClose={handleProviderMenuClose}
//             MenuListProps={{ 'aria-labelledby': 'provider-filter-button', sx: { p: 0 } }}
//             PaperProps={{ elevation: 3, sx: { width: '229px', borderRadius: '12px', mt: '8px', overflow: 'hidden' } }}
//         >
//             <Box sx={{ px: '16px', pt: '12px', pb: '8px' }}>
//                 <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Select Provider</Typography>
//             </Box>
//             <Divider />
//             <Box sx={{ py: '10px' }}>
//                 <FormGroup>
//                     <FormControlLabel
//                         control={ <Checkbox checked={tempProviderFilters.includes('GCP')} onChange={() => handleProviderCheckboxChange('GCP')} size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} /> }
//                         label={ <Box sx={{ display: 'flex', alignItems: 'center' }}><img src="/icons/google-cloud-icon-2048x1646-7admxejz.svg" alt="GCP" style={{ height: 27, width: 21, marginRight: 8 }} />GCP</Box> }
//                         sx={{ width: '100%', m: 0, px: '1px',pl:'6px', py: '4px', ...(tempProviderFilters.includes('GCP') && { backgroundColor: '#F3F8FE' }) }}
//                         componentsProps={{ typography: { sx: { color: tempProviderFilters.includes('GCP') ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                             <Box sx={{ height: '5px', backgroundColor: 'white', mx: 1 }} />

//                     <FormControlLabel
//                         control={ <Checkbox checked={tempProviderFilters.includes('AWS')} onChange={() => handleProviderCheckboxChange('AWS')} size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} /> }
//                         label={ <Box sx={{ display: 'flex', alignItems: 'center' }}><img src="/icons/aws.svg" alt="AWS" style={{ height: 20, width: 23, marginRight: 8 }} />AWS</Box> }
//                         sx={{ width: '100%', m: 0, px: '1px',pl:'6px', py: '4px', ...(tempProviderFilters.includes('AWS') && { backgroundColor: '#F3F8FE' }) }}
//                         componentsProps={{ typography: { sx: { color: tempProviderFilters.includes('AWS') ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                             <Box sx={{ height: '5px', backgroundColor: 'white', mx: 1}} />

//                     <FormControlLabel
//                         control={ <Checkbox checked={tempProviderFilters.includes('AZURE')} onChange={() => handleProviderCheckboxChange('AZURE')} size="small" sx={{ '&.Mui-checked': { color: '#0064FF' } }} /> }
//                         label={ <Box sx={{ display: 'flex', alignItems: 'center' }}><img src="/icons/azure-1.svg" alt="Azure" style={{ height: 18, width: 18, marginRight: 8 }} />Azure</Box> }
//                         sx={{ width: '100%', m: 0, px: '1px',pl:'6px', py: '4px', ...(tempProviderFilters.includes('AZURE') && { backgroundColor: '#F3F8FE' }) }}
//                         componentsProps={{ typography: { sx: { color: tempProviderFilters.includes('AZURE') ? '#333333' : '#666666', fontSize: '14px' } } }}
//                     />
//                 </FormGroup>
//             </Box>
//             <Divider />
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px' }}>
//                 <Button onClick={handleClearProvider} sx={{ textTransform: 'none', fontSize:'14px', color: tempProviderFilters.length > 0 ? '#333333' : '#7B7B7B', minWidth: 'auto', padding: '6px 8px' }}>Clear</Button>
//                 <Button onClick={handleApplyProvider} sx={{ textTransform: 'none', fontSize:'14px', color: '#0064FF', minWidth: 'auto', padding: '6px 8px' }}>Apply</Button>
//             </Box>
//         </Menu>

//         <Divider orientation="vertical" flexItem sx={{ mx: 1, my: '4px' }} />
//         <Button onClick={handleClearAllFilters} sx={{ textTransform: 'none', fontSize: '14px', fontWeight: 500, color: (statusFilter !== 'All' || providerFilters.length > 0) ? '#0064FF' : '#7B7B7B' }}>Clear Filter</Button>
//         <Box sx={{ flexGrow: 1 }} />
//         <CustomValidationBadge variant="dot" invisible={invalidCount === 0} sx={{ "& .MuiBadge-badge": { transform: 'translate(175px, -19px)' } }} />
//             <Button
//               ref={validationButtonRef}
//               variant="contained"
//               startIcon={
//                   <img
//                       src="/icons/validation-r.svg"
//                       alt="Validation Icon"
//                       style={{
//                           width: '12.14px',
//                           height: '11.28px',
//                       }}
//                   />
//               }
//               sx={{
//                   textTransform: 'none',
//                   fontWeight: 500,
//                   fontSize:'14px',
//                   bgcolor: 'rgba(247, 247, 247, 1)',
//                   color: 'text.primary',
//                   boxShadow: 'none',
//                   '&:hover': { boxShadow: 'none' },
//                   borderRadius: '8px'
//               }}
//               onClick={handleOpenValidationPanel}
//           >
//               Validation Result
//           </Button>
//       </Paper>

//       <Paper
//         elevation={0}
//         sx={{
//           width: '100%',
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           borderRadius: '8px',
//           overflow: 'hidden'
//         }}
//       >
//          {error ? (
//     <ErrorDSTableDisplay onRefresh={() => refetch()} />
//   ) : (
//     <>
//           <Box sx={{position: 'relative', flexGrow: 1 }}>
//             <TableContainer>
//               <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
//     <TableHead>
//         {/* MODIFIED: Re-balanced column widths to fix overlap issue */}
//         <TableRow sx={{ '& .MuiTableCell-root': { borderBottom: 'none', paddingTop: '30px' } }}>
//             <TableCell sx={{ width: '15%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Data Source Name</TableCell>
//             <TableCell sx={{ width: '10%', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Cloud Provider</TableCell>
//             <TableCell sx={{ width: '9%', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Status</TableCell>
//             <TableCell sx={{ width: '16%', fontSize: '12px', fontWeight: 500, color: '#666666', whiteSpace: 'nowrap' }}>Last Modified By</TableCell>
//             <TableCell sx={{ width: '15%', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Last Validated</TableCell>
//             <TableCell sx={{ width: '16%', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Added By</TableCell>
//             <TableCell sx={{ width: '13%', fontSize: '12px', fontWeight: 500, color: '#666666' }}>Added On</TableCell>
//             <TableCell sx={{ width: '60px' }} />
//         </TableRow>
//     </TableHead>
//     <TableBody>
//         {paginatedData.map((row, index) => (
//             <TableRow
//                 key={row.id}
//                 onClick={() => {
//                     setSelectedDataSource(row);
//                     setIsPanelOpen(true);
//                 }}
//                 onMouseEnter={() => setHoveredRowId(row.id)}
//                 onMouseLeave={() => setHoveredRowId(null)}
//                 sx={{
//                     cursor: 'pointer',
//                     '& td, & th': { border: 0, padding: '18px', height: '75px' },
//                     backgroundColor: isPanelOpen && selectedDataSource?.id === row.id ? 'rgba(242, 247, 255, 1)' : (index % 2 !== 0 ? 'transparent' : '#F9FAFB'),
//                     '&:hover': { backgroundColor: 'rgba(242, 247, 255, 1)' },
//                 }}
//             >
//                 {columnVisibility.dataSourceName && (
//                     <TableCell component="th" scope="row" sx={{
//                         fontSize: '14px',
//                         fontWeight: 600,
//                         color: 'text.primary',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis'
//                     }}>
//                         {row.name}
//                     </TableCell>
//                 )}
//                 {columnVisibility.cloudProvider && (
//                     <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                             <img src={getProviderIcon(row.providerType)} alt={row.providerType} style={{ width: '20px', height: '20px' }} />
//                             {row.providerType}
//                         </Box>
//                     </TableCell>
//                 )}
//                 {columnVisibility.status && (
//                     <TableCell>
//                         <Chip
//                             label={row.isSyncing ? 'Syncing' : row.validationStatus}
//                             size="small"
//                             sx={getStatusChipSx(row.isSyncing ? 'Syncing' : row.validationStatus)}
//                         />
//                     </TableCell>
//                 )}
//                 {columnVisibility.lastModifiedBy && (
//                     <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
//                             <Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>
//                                 {!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}
//                             </Avatar>
//                             {row.creator.name}
//                         </Box>
//                     </TableCell>
//                 )}
//                 {columnVisibility.lastValidated && (
//                     <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(row.lastValidatedAt)}</TableCell>
//                 )}
//                 {columnVisibility.addedBy && (
//                     <TableCell>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', whiteSpace: 'nowrap' }}>
//                             <Avatar alt={row.creator.name || ''} src={row.creator.photo || undefined} sx={{ width: '18px', height: '18px', fontSize: '14px' }}>
//                                 {!row.creator.photo && row.creator.name?.charAt(0).toUpperCase()}
//                             </Avatar>
//                             {row.creator.name}
//                         </Box>
//                     </TableCell>
//                 )}
//                 {columnVisibility.addedOn && (
//                     <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(row.createdAt)}</TableCell>
//                 )}
//                 <TableCell>
//                     {userRole !== 'viewer' && (
//                         <IconButton
//                             aria-label="actions"
//                             onClick={(event) => handleMenuOpen(event, row)}
//                             sx={{
//                                 visibility: hoveredRowId === row.id || (isActionMenuOpen && selectedDataSource?.id === row.id) ? 'visible' : 'hidden',
//                                 width: '32px', height: '32px', backgroundColor: '#FFFFFF',
//                                 border: ' rgb(203, 203, 203) solid 1px', borderRadius: '8px',
//                                 '&:hover': { backgroundColor: '#F5F5F5' }
//                             }}
//                         >
//                             <MoreHorizIcon sx={{ width: '18px', height: 'auto', color: '#333333' }} />
//                         </IconButton>
//                     )}
//                 </TableCell>
//             </TableRow>
//         ))}
//     </TableBody>
// </Table>
//             </TableContainer>
//         </Box>
//         <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, minHeight: '56px', padding: '0 24px', backgroundColor: '#FFFFFF' }}>
//             <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary' }}>Rows per page:</Typography>
//             <FormControl size="small">
//                 <Select
//                     value={rowsPerPage}
//                     onChange={handleRowsPerPageChange}
//                     sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', '.MuiOutlinedInput-notchedOutline': { border: 'none' }, '.MuiSelect-select': { padding: '4px 8px' }, }}
//                 >
//                     <MenuItem value={6}>5</MenuItem>
//                     <MenuItem value={10}>10</MenuItem>
//                     <MenuItem value={25}>20</MenuItem>
//                 </Select>
//             </FormControl>
//             <Typography sx={{ fontFamily: 'Inter', fontSize: '14px', color: 'text.secondary', fontWeight: 500 }}>
//                 {showingFrom} – {showingTo} of {filteredData.length}
//             </Typography>
//             <IconButton onClick={handlePreviousPage} disabled={page === 1} aria-label="previous page"><ArrowBackIosNewIcon sx={{ fontSize: '16px' }} /></IconButton>
//             <IconButton onClick={handleNextPage} disabled={page >= pageCount} aria-label="next page"><ArrowForwardIosIcon sx={{ fontSize: '16px' }} /></IconButton>
//         </Box>
//         </>
//   )}
//       </Paper>
//         <Drawer
//           anchor="right"
//           open={isPanelOpen}
//           onClose={handlePanelClose}
//           sx={{
//             zIndex: (theme) => theme.zIndex.modal + 1,
//           }}
//           PaperProps={{
//             sx: {
//               borderRadius: '12px 12px 12px 12px',
//               margin: '20px',
//               height: 'calc(100% - 40px)',
//               width: '450px',
//             },
//           }}
//         >
//   <DataSourceDetailPanel dataSourceId={selectedDataSource?.id || null} onClose={handlePanelClose} />
// </Drawer>
//       <Menu
//         anchorEl={columnMenuAnchorEl}
//         open={isColumnMenuOpen}
//         onClose={handleColumnSelectorClose}
//         MenuListProps={{ 'aria-labelledby': 'column-selector-button', sx: { p: 0 } }}
//         PaperProps={{ sx: { width: '280px', borderRadius: '8px', boxShadow: theme.shadows[2], mt: '8px', overflow: 'hidden' } }}
//       >
//         <Box sx={{ px: '16px', pt: '12px', pb: '8px',borderBottom: `1px solid ${theme.palette.divider}` }}>
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#666666', fontFamily: 'Inter', fontSize: '14px' }}>Column selector</Typography>
//         </Box>
//         {allColumns.map((column) => {
//           const isChecked = tempColumnVisibility[column.id as keyof typeof tempColumnVisibility] || false;
//           const getBackgroundColor = () => isChecked ? (column.locked ? '#F9FAFB' : 'rgba(237, 246, 255, 1)') : '#FFFFFF';
//           const getHoverBackgroundColor = () => isChecked ? (column.locked ? '#F0F2F5' : 'rgba(220, 235, 255, 1)') : theme.palette.action.hover;
//           return (
//             <MenuItem key={column.id} onClick={() => { if (!column.locked) { handleCheckboxChange({ target: { name: column.id, checked: !isChecked } } as React.ChangeEvent<HTMLInputElement>); } }} disableRipple sx={{ py: '10px', px: '20px', cursor: column.locked ? 'not-allowed' : 'pointer', backgroundColor: getBackgroundColor(), borderBottom: '4px solid #FFFFFF', '&:last-of-type': { borderBottom: 'none' }, '&:hover': { backgroundColor: getHoverBackgroundColor() } }}>
//               <Checkbox checked={isChecked} disabled={column.locked} size="small" sx={{ p: 0, mr: '12px', pointerEvents: 'none', color: column.locked ? theme.palette.action.disabled : undefined, '&.Mui-checked': { color: column.locked ? theme.palette.grey[600] : '#0064FF' } }} />
//               <ListItemText primary={column.label} sx={{ flexGrow: 1, '& .MuiListItemText-primary': { fontWeight: 400, fontSize: '14px', color: column.locked ? ' #666666' : ' #333333' } }} />
//               {column.locked && <img src="/icons/lock-icon.svg" alt="Locked" style={{ width: '16px', height: '16px', marginLeft: '8px', opacity: 0.5 }} />}
//             </MenuItem>
//           );
//         })}

//         <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: '6px', borderTop: `1px solid ${theme.palette.divider}`, alignItems: 'center' }}>
//           <Button onClick={handleResetColumns} sx={{ marginRight:'-10px',fontWeight: 500, fontSize: '14px', textTransform: 'none', color:' #7B7B7B' }}>Reset</Button>
//           <Button onClick={handleApplyColumns} sx={{ fontWeight: 500, fontSize: '14px', textTransform: 'none', color: ' #0064FF' }}>Apply</Button>
//         </Box>
//       </Menu>

//       <SuccessToast open={toastOpen} message={toastMessage} onClose={() => setToastOpen(false)} />
//       <Menu
//         anchorEl={actionMenuAnchorEl}
//         open={isActionMenuOpen}
//         onClose={handleMenuClose}
//         PaperProps={{ sx: { borderRadius: '8px', width: '200px' } }}
//       >
//         <MenuItem onClick={handleEdit}>
//           <ListItemIcon><img src="/icons/edit_icon.svg" alt="Edit" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon>
//           <ListItemText>Edit</ListItemText>
//         </MenuItem>
//         <Divider />
//         <MenuItem onClick={handleDelete} >
//           <ListItemIcon><img src="/icons/delete_icon.svg" alt="Delete" style={{ width: '16px', height: '16px', marginLeft: '2px' }} /></ListItemIcon>
//           <ListItemText sx={{ color:' #CA2B20', fontWeight:400 , fontSize:'14px'}} >Delete</ListItemText>
//         </MenuItem>
//       </Menu>

//       <Drawer
//           anchor="right"
//           open={isValidationPanelOpen}
//           onClose={handleCloseValidationPanel}
//           sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
//           PaperProps={{
//             sx: {
//               borderRadius: '12px 12px 12px 12px',
//               margin: '20px',
//               height: 'calc(100% - 40px)',
//               width: '450px',
//             },
//           }}
//         >
//           <ValidationResultPanel
//             onClose={handleCloseValidationPanel}
//             dataSources={filteredData as unknown as ValidationDataSource[]}
//             loading={isLoadingValidation}
//             error={validationError}
//             onRefresh={fetchValidationData}
//           />
//         </Drawer>

//       <DeleteDataSourceDialog
//         open={isDeleteDialogOpen}
//         onClose={handleCloseDeleteDialog}
//         onConfirm={handleConfirmDelete}
//         dataSource={selectedDataSource}
//         isDeleting={deleteLoading}
//       />
//       <Popover
//         open={showValidationPopover}
//         anchorEl={validationButtonRef.current}
//         onClose={handleDismissValidationPopover}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//         transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//         PaperProps={{
//           sx: {
//             p: 2, mt: 26, ml: 67, borderRadius: '12px', bgcolor: 'rgba(225, 239, 255, 1)',
//             boxShadow: '0px 5px 15px rgba(0,0,0,0.1)',
//             '&::after': {
//               content: '""', position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
//               borderWidth: '8px', borderStyle: 'solid', borderColor: 'transparent transparent rgba(225, 239, 255, 1) transparent', marginRight:'100px',
//             },
//           },
//         }}
//       >
//         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', maxWidth: 300 }}>
//           <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '16px', mb: 1 }}>Validation issues</Typography>
//           <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>Some data sources have validation issues. View the results to address them.</Typography>
//           <Button onClick={handleDismissValidationPopover} sx={{ alignSelf: 'flex-end', fontWeight: 600, textTransform: 'none' }}>Got It</Button>
//         </Box>
//       </Popover>
//     </Box>
//   );
// };

// export default DataSourcesPage;